import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { Role } from '@/helpers/role.js'
import axios from 'axios';
import dns from "../../dns.json";
//define a routes
const routes = [
    {
        path: '/',
        redirect: '/LoginPage'
    },
    {
        path: '/QrCode',
        name: 'QrCode',
        component: () => import( /* webpackChunkName: "login" */ '@/views/LandingPage/QrCode.vue'),
        meta: {
            title: "SI PNBP-PKH"
        }
    },
    {
        path: '/statistik',
        name: 'Statistik',
        component: () => import( /* webpackChunkName: "login" */ '@/views/LandingPage/Statistik.vue'),
        meta: {
            title: "SI PNBP-PKH"
        }
    },
    {
        path: '/konsultasi',
        name: 'Konsultasi',
        component: () => import( /* webpackChunkName: "login" */ '@/views/LandingPage/Konsultasi.vue'),
        meta: {
            title: "SI PNBP-PKH"
        }
    },
    {
        path: '/landingpage',
        name: 'LandingPage',
        component: () => import( /* webpackChunkName: "login" */ '@/views/LandingPage/LandingPage.vue'),
        meta: {
            title: "SI PNBP-PKH"
        }
    },
    {
        path: '/blog',
        name: 'BlogPage',
        component: () => import( /* webpackChunkName: "login" */ '@/views/LandingPage/BlogPage.vue'),
        meta: {
            title: "SI PNBP-PKH"
        }
    },
    {
        path: '/dokumen',
        name: 'DokumenPage',
        component: () => import( /* webpackChunkName: "login" */ '@/views/LandingPage/DokumenPage.vue'),
        meta: {
            title: "SI PNBP-PKH"
        }
    },
    {
        path: '/LoginPage',
        name: 'LoginPage',
        component: () => import( /* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
        meta: {
            title: "Login Page"
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import( /* webpackChunkName: "register" */ '@/views/auth/Register.vue')
    },
    {
        path: '/lupapassword',
        name: 'Lupa Password',
        component: () => import(/* webpackChunkName: "register" */ '@/views/auth/LupaPassword.vue')
    },
    {
        path: '/verifikasiOtp',
        name: 'verifikasiotp',
        component: () => import('@/views/auth/VerifikasiOtp.vue')
    },
    {
        path: '/VerifyUser/:otp',
        name: 'verifikasiUser',
        component: () => import('@/views/auth/InputVerifikasi.vue')
    },
    {
        path: '/InputOTP',
        name: 'InputOTP',
        component: () => import('@/views/auth/InputOTPLupaPass.vue')
    },
    {
        path: '/ResetPass',
        name: 'ResetPass',
        component: () => import('@/views/auth/ResetPass.vue')
    },
    {
        path: '/GantiPassword',
        name: 'GantiPassword',
        component: () => import('@/views/auth/GantiPassword.vue')

    },
    {
        path: '/ResetPassword',
        name: 'ResetLupaPassword',
        component: () => import('@/views/auth/UpdateLupaPassword.vue'),
    },
    {
        path: '/RegistrasiAkun',
        component: () => import('@/views/auth/RegistrasiAkun.vue'),
        name: 'RegistrasiAkun',
    },
    {
        path: '/GenerateDataSurat',
        component: () => import('@/views/form_persuratan_online/GenerateDataSuratOnline.vue'),
        name: 'generatedatasurat',
    },
    {
        path: '/ManajemenNomorJenisSurat',
        component: () => import('@/views/form_persuratan_online/ManajemenNomorJenisSurat.vue'),
        name: 'manajemennomorjenissurat',
    },
    {
        path: '/ObjekPnbp',
        name: 'ObjekPnbp',
        component: () => import('@/views/LandingPage/ObjekPnbp.vue'),
    },
    {
        path: '/Panduan',
        name: 'Panduan',
        component: () => import('@/views/LandingPage/PanduanPage.vue'),
    },
    {
        path: '/Dashboard',
        component: () => import( /* webpackChunkName: "dashboard" */ '@/views/dashboard/MainLayout.vue'),
        name: 'dashboard',
        children: [
            {
                path: 'about',
                name: 'about',
                component: () => import(/* webpackChunkName: "dashboard" */ '@/views/about.vue')
            }
        ]
    },

    {
        path: '/ttdSurat',
        component: () => import('@/components/ttdsurat/index.vue'),
        name: 'TTD_Surat_Free',
    },

    {
        path: '/signer',
        // component: () => import('@/components/ttdsurat/m_signer.vue'),
        component: () => import('@/components/Signer/index.vue'),
        name: 'Signer',
    },

    {
        path: '/surat',
        component: () => import('@/components/ttdsurat/m_surat.vue'),
        name: 'M_Surat',
    },

    // Akhir contoh 
    
    /*-- New Routes From Here --*/    
    // {
    //     path: '',
    //     component: () => import('@/views/admindashboard/AdminHome.vue'),
    //     // name: 'administrator',
    //     name: 'adminhome',
    // },
    // {
    //     path: 'FormulirSKPPKH',
    //     component: () => import('@/views/admindashboard/Skppkh.vue'),
    //     name: 'formuliradminsk',
    // },
    // {
    //     path: 'FormulirSKPPKH/detail/:kode_wb',
    //     component: () => import('@/views/admindashboard/MenuUtamaPPKH.vue'),
    //     name: 'formulirskadmin',
    // },
    // {
    //     path: 'JenisPenggunaan',
    //     component: () => import('@/views/admindashboard/Profil/JenisPenggunaan.vue'),
    //     name: 'AdminJenisPenggunaan',
    // },
    // {
    //     path: 'pembayaran/:kode_wb',
    //     component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranKode.vue'),
    //     name: 'PembayaranAdminKode'
    // },
    // {
    //     path: 'pembayaran_rinci/:kode_wb/:thn',
    //     component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranRinci.vue'),
    //     name: 'PembayaranAdminRinci',
    //     props: true
    // },
    // {
    //     path: 'pembayaran_lunas/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/telahDibayar.vue'),
    //     name: 'PembayaranLunas',
    // },
    // {
    //     path: 'invoice_pembayaran/:idx',
    //     component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/Invoice_Pembayaran_dua.vue'),
    //     name: 'InvoiceBillingAdminDetail',
    // },
    // //Route Persuratan
    // {
    //     path: 'Persuratan/:kode_wb',
    //     component: () => import('@/views/admindashboard/Persuratan/index.vue'),
    //     name: 'PersuratanWB',
    // },
        
    // {
    //     path: 'RencanaKonsepSurat',
    //     component: () => import('@/views/admindashboard/Persuratan/late_mails.vue'),
    //     name: 'RencanaKonsepSuratAdmin',
    // },
    
    // {
    //     path: 'KirimSurat',
    //     component: () => import('@/components/kirimsurat/index.vue'),
    //     name: 'KirimSurat',
    // },

    // {
    //     path: 'KirimSuratMultiPenerima',
    //     component: () => import('@/components/kirimsurat/InputMultiPenerima.vue'),
    //     name: 'InputMultiPenerima',
    // },
    
    // {
    //     path: 'SuratTelahKirim',
    //     component: () => import('@/components/kirimsurat/index_telah.vue'),
    //     name: 'SuratTelahKirim',
    // },

    // {
    //     path: 'ttdSurat',
    //     component: () => import('@/components/ttdsurat/index.vue'),
    //     name: 'TTD_Surat',
    // },

    // {
    //     path: 'ttdSurat/:idx',
    //     component: () => import('@/components/ttdsurat/preview.vue'),
    //     name: 'TTD_Surat_preview',
    // },

    // {
    //     path: 'ttdSurat/surat_jatuh_tempo/:idx',
    //     component: () => import('@/components/ttdsurat/surat_jatuh_tempo.vue'),
    //     name: 'TTD_Surat_Jatuh_Tempo',
    // },

    // {
    //     path: 'Persuratan/surat_manual/:idx',
    //     component: () => import('@/components/ttdsurat/surat_manual.vue'),
    //     name: 'Surat Manual',
    // },

    // {
    //     path: 'ttdSurat/tagihan',
    //     component: () => import('@/components/ttdsurat/surat_tagihan.vue'),
    //     name: 'TTD_Surat_preview_tagihan',
    // },


    // {
    //     path: 'ttdSurat/penetapan/:id',
    //     component: () => import('@/components/ttdsurat/surat_penetapan.vue'),
    //     name: 'TTD_Surat_preview_penetapan',
    // },

    // {
    //     path: 'ttdSurat/penyerahan/:id',
    //     component: () => import('@/components/ttdsurat/surat_penyerahan.vue'),
    //     name: 'TTD_Surat_preview_penyerahan',
    // },


    // {
    //     path: 'ttdSurat/surat_manual/:id',
    //     component: () => import('@/components/ttdsurat/surat_manual.vue'),
    //     name: 'TTD_Surat_preview_manual',
    // },

    // {
    //     path: 'ttdSurat/peringatan_pertama',
    //     component: () => import('@/components/ttdsurat/surat_peringatan_pertama.vue'),
    //     name: 'TTD_Surat_preview_peringatan_pertama',
    // },

    // {
    //     path: 'ttdSurat/peringatan_kedua',
    //     component: () => import('@/components/ttdsurat/surat_peringatan_kedua.vue'),
    //     name: 'TTD_Surat_preview_peringatan_kedua',
    // },

    // {
    //     path: 'ttdSurat/peringatan_ketiga',
    //     component: () => import('@/components/ttdsurat/surat_peringatan_ketiga.vue'),
    //     name: 'TTD_Surat_preview_peringatan_ketiga',
    // },


    // {
    //     path: 'ttdSurat/tagihan_kedua/:idx',
    //     component: () => import('@/components/ttdsurat/surat_tagihan_kedua.vue'),
    //     name: 'TTD_Surat_preview_tagihan_kedua',
    // },

    // {
    //     path: 'ttdSurat/tagihan_ketiga/:idx',
    //     component: () => import('@/components/ttdsurat/surat_tagihan_ketiga.vue'),
    //     name: 'TTD_Surat_preview_tagihan_ketiga',
    // },

    // {
    //     path: 'ttdSurat/tagihan/:id',
    //     component: () => import('@/components/ttdsurat/surat_tagihan.vue'),
    //     name: 'TTD_Surat_Tagihan',
    // },

    // {
    //     path: 'korektor_surat',
    //     component: () => import('@/components/Korektor/index.vue'),
    //     name: 'Korektor_Surat',
    // },

    // {
    //     path: 'korektor_surat/:id',
    //     component: () => import('@/components/Korektor/edit.vue'),
    //     name: 'Korektor_Surat_id',
    // },

    // {
    //     path: 'surat',
    //     component: () => import('@/components/Surat/index.vue'),
    //     name: 'Surat_Admin',
    // },


    // {
    //     path: 'pilih_kode_surat',
    //     component: () => import('@/components/Surat/pilih_kode.vue'),
    //     name: 'Pilih Kode Surat',
    // },

    // {
    //     path: 'kodeNomorSurat',
    //     component: () => import('@/components/KodeNomorSurat/index.vue'),
    //     name: 'Kode surat',
    // },

    // {
    //     path: 'kodeNomorSurat/:idx',
    //     component: () => import('@/components/KodeNomorSurat/edit.vue'),
    //     name: 'Kode Nomor Surat Edit',
    // },

    // {
    //     path: 'KonfigurasiSurat',
    //     component: () => import('@/components/KonfigurasiSurat/index.vue'),
    //     name: 'Konfigurasi Surat',
    // },

    // {
    //     path: 'KonfigurasiSurat/JenisSurat',
    //     component: () => import('@/components/KonfigurasiSurat/k_jenis_surat.vue'),
    //     name: 'Jenis Surat',
    // },

    // {
    //     path: 'KonfigurasiSurat/JenisSurat/:kode',
    //     component: () => import('@/components/KonfigurasiSurat/edit_k_jenis_surat.vue'),
    //     name: 'Jenis Surat Edit',
    // },

    // {
    //     path: 'KonfigurasiSurat/templateSurat',
    //     component: () => import('@/components/templateSurat/index.vue'),
    //     name: 'Template Surat',
    // },

    // {
    //     path: 'KonfigurasiSurat/templateSurat/:idx',
    //     component: () => import('@/components/templateSurat/edit.vue'),
    //     name: 'Template Surat Edit',
    // },

    // {
    //     path: 'KonfigurasiSurat/korektorSurat',
    //     component: () => import('@/components/Korektor/index.vue'),
    //     name: 'Korektor Surat',
    // },

    // {
    //     path: 'KonfigurasiSurat/korektorSurat/:id',
    //     component: () => import('@/components/Korektor/edit.vue'),
    //     name: 'Edit Korektor Surat',
    // },

    // {
    //     path: 'signer',
    //     component: () => import('@/components/Signer/index.vue'),
    //     name: 'Signer_Admin',
    // },
    // {
    //     path: 'signer/:idx',
    //     component: () => import('@/components/Signer/edit.vue'),
    //     name: 'Signer Edit Admin ',
    // },

    // //Automatic Blocking System (ABS)
    // {
    //     path: 'GenerateABS',
    //     component: () => import('@/views/admindashboard/ABS/index.vue'),
    //     name: 'GenerateABS',
    // },

    // {
    //     path: 'ManajemenABS',
    //     component: () => import('@/views/admindashboard/ABS/index.vue'),
    //     name: 'ManajemenABS',
    // },

    // {
    //     path: 'DetailABS/:id_abs',
    //     component: () => import('@/views/admindashboard/ABS/DetailABS.vue'),
    //     name: 'DetailABS',
    // },
    
    // //Kustomisasi Data
    // {
    //     path: 'KustomisasiData',
    //     component: () => import('@/components/kustomisasi/a_penerbitansurat.vue'),
    //     name: 'Kustomisasi',
    // },

    // {
    //     path: 'KustomisasiData/:kode_wb',
    //     component: () => import('@/views/admindashboard/KustomisasiData/ListPertahun.vue'),
    //     name: 'KustomisasiAdmin',
    // },

    // {
    //     path: 'KustomisasiData/Edit/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/KustomisasiData/edit.vue'),
    //     name: 'EditKustomisasiAdmin'
    // },
    // {
    //     path: 'Pelaporan',
    //     component: () => import('@/views/admindashboard/Pelaporan/index.vue'),
    //     name: 'pelaporan'
    // },
    // {
    //     path: 'Pelaporan/LaporanTarget',
    //     component: () => import('@/views/admindashboard/Pelaporan/laporan_target.vue'),
    //     name: 'laporantarget',
    // },
    // {
    //     path: 'Pelaporan/LaporanRealisasi',
    //     component: () => import('@/views/admindashboard/Pelaporan/laporan_realisasi.vue'),
    //     name: 'laporanrealisasi',
    // },
    // {
    //     path: 'Pelaporan/LaporanPiutang',
    //     component: () => import('@/views/admindashboard/Pelaporan/laporan_piutang.vue'),
    //     name: 'LaporanPiutang',
    // },
    // {
    //     path: 'Pelaporan/LaporanVerifikasi',
    //     component: () => import('@/views/admindashboard/Pelaporan/laporan_verifikasi.vue'),
    //     name: 'LaporanVerifikasi',
    // },
    // {
    //     path: 'Pelaporan/TargetProvinsi',
    //     component: () => import('@/views/admindashboard/Pelaporan/target_provinsi.vue'),
    //     name: 'TargetProvinsi',
    // },
    // {
    //     path: 'Pelaporan/LaporanPiutangV2',
    //     component: () => import('@/views/admindashboard/Pelaporan/laporan_piutang_v2.vue'),
    //     name: 'LaporanPiutangV2ADM',
    // },
    // {
    //     path: 'verifikasiadmin/:kode',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/list_verifikasi.vue'),
    //     name: 'VerifikasiKode',
    // },

    // //Verifikasi Pembayaran
    // {
    //     path: 'Verifikasi_Pembayaran',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/index.vue'),
    //     name: 'VerifikasiPembayaran',
    // },

    // {
    //     path: 'Verifikasi_Pembayaran/Tambah_Verifikasi',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/tambah_verifikasi.vue'),
    //     name: 'TambahVerifikasi',
    // },
    // {
    //     path: 'Verifikasi_Pembayaran/Edit/:kode/:tahun',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/EditDataVerifikasi.vue'),
    //     name: 'EditVerifikasi',
    // },
    // {
    //     path: 'VerifikasiPembayaran/BatalKegiatan/:kode',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/BatalValidasi.vue'),
    //     name: 'BatalValidasi',
    // },
    // {
    //     path: 'DaftarRencana/:kode',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/daftar_kegiatan.vue'),
    //     name: 'DaftarRencanaVerifikasi',
    //     props: true,
    // },
    // {
    //     path: 'HasilVerifikasi/:kode_verifikasi/:tahun/:kode_wb',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/Hasil_verifikasi.vue'),
    //     name: 'HasilVerifikasi',
    // },
    // {
    //     path: 'HasilVerifikasiV1/:kode_wb',
    //     component: () => import('@/views/admindashboard/VerifikasiPembayaran/InputVerifikasiLegacy.vue'),
    //     name: 'HasilVerifikasiV1ADM',
    // },
    
    // // Pembayaran Obsolete
    // {
    //     path: 'Pembayaran/DashboardPembayaranSimponi',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranSimponi/index.vue'),
    //     name: 'DashboardSimponi',
    // },

    // //Pembayaran Angsur
    // {
    //     path: 'Pembayaran/Angsur',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/index-angsur.vue'),
    //     name: 'Pembayaran Angsur',
    // },

    // {
    //     path: 'Pembayaran/Pengangsuran/:kode_wb/:tahun/:idx',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/index.vue'),
    //     name: 'Pengangsuran Detail',
    // },

    // {
    //     path: 'Pembayaran/Pengangsuran/Permohonan/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/TambahPermohonan.vue'),
    //     name: 'Tambah Permohonan',
    // },

    // {
    //     path: 'Pembayaran/Pengangsuran/Tambah_Persetujuan/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/TambahPersetujuan.vue'),
    //     name: 'Tambah Persetujuan',
    // },

    // {
    //     path: 'Pembayaran/Pengangsuran/Tambah_Data_Angsur/:kode_wb/:tahun/:idx',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/TambahDataRencanaPengangsuran.vue'),
    //     name: 'Tambah Rencana Pengangsuran',
    // },

    // //Pembayaran KPKNL
    // {
    //     path: 'Pembayaran/SKKPKNL',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/TampilSK.vue'),
    //     name: 'SKKPKNL'
    // },
    // {
    //     path: 'Pembayaran/KPKNL/:kode_wb',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/index-kpknl.vue'),
    //     name: 'PembayaranKPKNL'
    // },
    // {
    //     path: 'Pembayaran/KPKNL/detail/:kode_wb/:thn',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/index.vue'),
    //     name: 'PembayaranKpknlDetail'
    // },
    // {
    //     path: 'Pembayaran/KPKNL/TambahDataPembayaran/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/TambahDataPembayaran.vue'),
    //     name: 'Tambah Data Pembayaran',
    // },
    // {
    //     path: 'Pembayaran/KPKNL/TambahSP3N/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/EditSP3N.vue'),
    //     name: 'EditDataSP3N',
    // },
    // {
    //     path: 'Pembayaran/KPKNL/CrashProgram/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/CrashProgram.vue'),
    //     name: 'CrashProgram',
    // },
    // {
    //     path: 'Pembayaran/KPKNL/Tambah_SPUPN/:kode_wb/:tahun',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/penyerahan.vue'),
    //     name: 'Tambah SPUPN',
    // },
    // {
    //     path: 'EditPembayaran/KPKNL/:idx',
    //     component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/EditDataPembayaran.vue'),
    //     name: 'Edit Pembayaran',
    // },

    // //Persuratan
    // {
    //     path: 'Persuratan/DashboardSuratOnline',
    //     component: () => import('@/views/admindashboard/DashboardSuratOnline/index.vue'),
    //     name: 'DashboardSuratOnline',
    // },

    // {
    //     path: 'Persuratan/DaftarKonsepSurat',
    //     component: () => import('@/views/admindashboard/DaftarKonsepSurat/index.vue'),
    //     name: 'DaftarKonsepSurat',
    // },

    // {
    //     path: 'Persuratan/DaftarKonsepSurat/Tambah',
    //     // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
    //     component: () => import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
    //     name: 'TambahKonsepSurat',
    // },
    // {
    //     path: 'Persuratan/DaftarKonsepSurat/:idx',
    //     // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
    //     component: () => import('@/views/admindashboard/DaftarKonsepSurat/edit.vue'),
    //     name: 'EditKonsepSurat',
    // },
    // {
    //     path: 'Persuratan/DaftarSuratDigital',
    //     component: () => import('@/views/admindashboard/DaftarSuratDigital/index.vue'),
    //     name: 'DaftarSuratDigital',
    // },

    // ///KorektorSuratBerjenjang
    // {
    //     path: 'Persuratan/FiturKoreksiSuratBerjenjang',
    //     component: () => import('@/views/admindashboard/DaftarSuratDigital/index.vue'),
    //     name: 'DaftarSuratDigital',
    // },

    // //Route Baseline
    // {
    //     path: 'Baseline/:kode_wb',
    //     component: () => import('@/views/admindashboard/Baseline/DaftarBaseline.vue'),
    //     name: 'DaftarAdminBaseline',
    // },
    // {
    //     path: 'BaselineNew/:kode_wb',
    //     component: () => import('@/views/admindashboard/Baseline/Baseline.vue'),
    //     name: 'AdminBaseline',
    // },
    // {
    //     path: 'Baseline/DetailBaseline/:kode_wb/:id_baseline',
    //     component: () => import('@/views/admindashboard/Baseline/DetailBaseline2.vue'),
    //     name: 'AdminDetailBaseline',
    // },
    // {
    //     path: 'Baseline/DetailBaselineT0/:kode_wb/:id_baseline',
    //     component: () => import('@/views/admindashboard/Baseline/DetailBaselineT0.vue'),
    //     name: 'AdminDetailBaselineT0',
    // },
    // {
    //     path: 'Baseline/DetailBaselinePertahun/:kode_wb/:id_baseline',
    //     component: () => import('@/views/admindashboard/Baseline/DetailBaselinePertahun.vue'),
    //     name: 'AdminDetailBaselinePertahun',
    // },
    // {
    //     path: 'JenisTarif',
    //     component: () => import('@/views/admindashboard/Baseline/JenisTarif.vue'),
    //     name: 'AdminJenisTarif',
    // },
    // {
    //     path: 'JenisArealTerganggu',
    //     component: () => import('@/views/admindashboard/Baseline/JenisArealTerganggu.vue'),
    //     name: 'AdminJenisArealTerganggu',
    // },
    // //Route Piutang
    // {
    //     path: 'Piutang/:kode_wb',
    //     component: () => import('@/views/admindashboard/Piutang/DaftarPiutang.vue'),
    //     name: 'DaftarAdminPiutang',
    // },
    // {
    //     path: 'Piutang/Detail/:kode_wb/:thn',
    //     component: () => import('@/views/admindashboard/Piutang/DetailPiutang.vue'),
    //     name: 'DetailAdminPiutang',
    // },
    // //Route Profil
    // // {
    // //     path: 'Profil/:kode_wb',
    // //     component: () => import('@/views/admindashboard/Profil/ProfilPPKH.vue'),
    // //     name: 'AdminProfil',
    // // },

    // //Route manajemen user
    // {
    //     path: 'DaftarUser',
    //     component: () => import('@/views/admindashboard/User/DaftarUser.vue'),
    //     name: 'AdminDaftarUser',
    // },
    // {
    //     path: 'DetailUser/:id',
    //     component: () => import('@/views/admindashboard/User/DetailUser.vue'),
    //     name: 'AdminDetailUser',
    // },

    // //Route daftar konsultasi
    // {
    //     path: 'DaftarKonsultasi',
    //     component: () => import('@/views/admindashboard/Konsultasi/DaftarKonsultasi.vue'),
    //     name: 'AdminDaftarKonsultasi',
    // },
    // {
    //     path: 'DaftarPokja',
    //     component: () => import('@/views/admindashboard/Konsultasi/DaftarPokja.vue'),
    //     name: 'DaftarPokja',
    // },
    // {
    //     path: 'DaftarSubyek',
    //     component: () => import('@/views/admindashboard/Konsultasi/DaftarSubyek.vue'),
    //     name: 'DaftarSubyek',
    // },
    // {
    //     path: 'EditKonsultasi/:idx',
    //     component: () => import('@/views/admindashboard/Konsultasi/EditKonsultasi.vue'),
    //     name: 'AdminEditKonsultasi',
    // },
    // //Modul Manajemen Pekerjaan
    // {
    //     path: 'ManageJob',
    //     component: () => import('@/views/admindashboard/ManageJob/index.vue'),
    //     name: 'Manajemen Pekerjaan',
    // },
    // // {
    // //     path: 'detailbaselines',
    // //     component: () => import('@/components/Baselinemap/detailbaselines.vue'),
    // //     name: 'detailbaselines',
    // // },

    // //Modul SOP
    // {
    //     path: 'SOP',
    //     component: () => import('@/components/SOP/index.vue'),
    //     name: 'SOP',
    // },
    // {
    //     path: 'addSOP',
    //     component: () => import('@/components/SOP/addsop.vue'),
    //     name: 'addSOP',
    // },

    // {
    //     path: 'detailsop/:kode_sop',
    //     component: () => import('@/components/SOP/detailsop.vue'),
    //     name: 'detailSOP',
    // },
    // {
    //     path: 'flowchartsop/:kode_sop',
    //     component: () => import('@/components/SOP/flowchartsop.vue'),
    //     name: 'FlowchartSOP',
    // },

    // //Modul CRM Customer Relation Management
    // {
    //     path: 'Livechat',
    //     component: () => import('@/views/admindashboard/Chat/LiveChat.vue'),
    //     name: 'LiveChatGlobal',
    // },
    // {
    //     path: 'Broadcast',
    //     component: () => import('@/views/admindashboard/Chat/Broadcast.vue'),
    //     name: 'Broadcast',
    // },
    // //Tanggal Libur
    // {
    //     path: 'TanggalLibur',
    //     component: () => import('@/views/admindashboard/Tanggal/tanggal_libur.vue'),
    //     name: 'AdminTanggalLibur',
    // },
    // //Oper Service
    // {
    //     path: 'OpenService',
    //     component: () => import('@/views/admindashboard/Service/open_service.vue'),
    //     name: 'AdminOpenService',
    // },

    // //Jenis Dokumen
    // {
    //     path: 'JenisDokumen',
    //     component: () => import('@/components/Dokumen/JenisDokumen.vue'),
    //     name: 'AdminJenisDokumen',
    // },

    // //PNBP Kompensasi
    // {
    //     path: 'PNBPKompensasi/:kode_wb',
    //     component: () => import('@/views/admindashboard/PNBPKompensasi/PNBPKompensasi.vue'),
    //     name: 'PNBPKompensasiAdmin',
    // },

    // //Agenda
    // {
    //     path: 'Agenda',
    //     component: () => import('@/views/admindashboard/Agenda/DaftarAgenda.vue'),
    //     name: 'AgendaAdmin',
    // },
    // {
    //     path: 'DetailAgenda/:id',
    //     component: () => import('@/views/admindashboard/Agenda/DetailAgenda.vue'),
    //     name: 'DetailAgendaAdmin',
    // },

    //Manajemen PPKH
    // {
    //     path: 'ManajemenPPKH/:kode_wb',
    //     component: () => import('@/views/admindashboard/ManajemenPPKH/manajemenPPKH.vue'),
    //     name: 'ManajemenPPKHADM',
    // },
        

    /*-- New Routes To Here --*/
    
    
    {
        path: '/PNBP-PKH/',
        component: () => import( /* webpackChunkName: "dashboard" */ '@/views/admindashboard/AdminDashboard.vue'),
        name: 'AdminDashboard',
        children: [
            {
                path: '',
                component: () => import('@/views/admindashboard/AdminHome.vue'),
                // name: 'administrator',
                name: 'adminhome',
            },
            {
                path: 'FormulirSKPPKH',
                component: () => import('@/views/admindashboard/Skppkh.vue'),
                name: 'formuliradminsk',
            },
            {
                path: 'FormulirSKPPKH/detail/:kode_wb',
                component: () => import('@/views/admindashboard/MenuUtamaPPKH.vue'),
                name: 'formulirskadmin',
            },
            {
                path: 'JenisPenggunaan',
                component: () => import('@/views/admindashboard/Profil/JenisPenggunaan.vue'),
                name: 'AdminJenisPenggunaan',
            },
            {
                path: 'pembayaran/:kode_wb',
                component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranKode.vue'),
                name: 'PembayaranAdminKode'
            },
            {
                path: 'pembayaran_rinci/:kode_wb/:thn',
                component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranRinci.vue'),
                name: 'PembayaranAdminRinci',
                props: true
            },
            {
                path: 'pembayaran_lunas/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/telahDibayar.vue'),
                name: 'PembayaranLunas',
            },
            {
                path: 'invoice_pembayaran/:idx',
                component: () => import('@/views/admindashboard/pembayaran/MenuUtamaPembayaran/Invoice_Pembayaran_dua.vue'),
                name: 'InvoiceBillingAdminDetail',
            },
            //Route Persuratan
            {
                path: 'Persuratan/:kode_wb',
                component: () => import('@/views/admindashboard/Persuratan/index.vue'),
                name: 'PersuratanWB',
            },
             
            {
                path: 'RencanaKonsepSurat',
                component: () => import('@/views/admindashboard/Persuratan/late_mails.vue'),
                name: 'RencanaKonsepSuratAdmin',
            },
            
            {
                path: 'KirimSurat',
                component: () => import('@/components/kirimsurat/index.vue'),
                name: 'KirimSurat',
            },

            {
                path: 'KirimSuratMultiPenerima',
                component: () => import('@/components/kirimsurat/InputMultiPenerima.vue'),
                name: 'InputMultiPenerima',
            },
            
            {
                path: 'SuratTelahKirim',
                component: () => import('@/components/kirimsurat/index_telah.vue'),
                name: 'SuratTelahKirim',
            },

            {
                path: 'ttdSurat',
                component: () => import('@/components/ttdsurat/index.vue'),
                name: 'TTD_Surat',
            },

            {
                path: 'ttdSurat/:idx',
                component: () => import('@/components/ttdsurat/preview.vue'),
                name: 'TTD_Surat_preview',
            },

            {
                path: 'ttdSurat/surat_jatuh_tempo/:idx',
                component: () => import('@/components/ttdsurat/surat_jatuh_tempo.vue'),
                name: 'TTD_Surat_Jatuh_Tempo',
            },

            {
                path: 'Persuratan/surat_manual/:idx',
                component: () => import('@/components/ttdsurat/surat_manual.vue'),
                name: 'Surat Manual',
            },

            {
                path: 'ttdSurat/tagihan',
                component: () => import('@/components/ttdsurat/surat_tagihan.vue'),
                name: 'TTD_Surat_preview_tagihan',
            },


            {
                path: 'ttdSurat/penetapan/:id',
                component: () => import('@/components/ttdsurat/surat_penetapan.vue'),
                name: 'TTD_Surat_preview_penetapan',
            },

            {
                path: 'ttdSurat/penyerahan/:id',
                component: () => import('@/components/ttdsurat/surat_penyerahan.vue'),
                name: 'TTD_Surat_preview_penyerahan',
            },


            {
                path: 'ttdSurat/surat_manual/:id',
                component: () => import('@/components/ttdsurat/surat_manual.vue'),
                name: 'TTD_Surat_preview_manual',
            },

            {
                path: 'ttdSurat/peringatan_pertama',
                component: () => import('@/components/ttdsurat/surat_peringatan_pertama.vue'),
                name: 'TTD_Surat_preview_peringatan_pertama',
            },

            {
                path: 'ttdSurat/peringatan_kedua',
                component: () => import('@/components/ttdsurat/surat_peringatan_kedua.vue'),
                name: 'TTD_Surat_preview_peringatan_kedua',
            },

            {
                path: 'ttdSurat/peringatan_ketiga',
                component: () => import('@/components/ttdsurat/surat_peringatan_ketiga.vue'),
                name: 'TTD_Surat_preview_peringatan_ketiga',
            },


            {
                path: 'ttdSurat/tagihan_kedua/:idx',
                component: () => import('@/components/ttdsurat/surat_tagihan_kedua.vue'),
                name: 'TTD_Surat_preview_tagihan_kedua',
            },

            {
                path: 'ttdSurat/tagihan_ketiga/:idx',
                component: () => import('@/components/ttdsurat/surat_tagihan_ketiga.vue'),
                name: 'TTD_Surat_preview_tagihan_ketiga',
            },

            {
                path: 'ttdSurat/tagihan/:id',
                component: () => import('@/components/ttdsurat/surat_tagihan.vue'),
                name: 'TTD_Surat_Tagihan',
            },

            {
                path: 'korektor_surat',
                component: () => import('@/components/Korektor/index.vue'),
                name: 'Korektor_Surat',
            },

            {
                path: 'korektor_surat/:id',
                component: () => import('@/components/Korektor/edit.vue'),
                name: 'Korektor_Surat_id',
            },

            {
                path: 'surat',
                component: () => import('@/components/Surat/index.vue'),
                name: 'Surat_Admin',
            },


            {
                path: 'pilih_kode_surat',
                component: () => import('@/components/Surat/pilih_kode.vue'),
                name: 'Pilih Kode Surat',
            },

            {
                path: 'kodeNomorSurat',
                component: () => import('@/components/KodeNomorSurat/index.vue'),
                name: 'Kode surat',
            },

            {
                path: 'kodeNomorSurat/:idx',
                component: () => import('@/components/KodeNomorSurat/edit.vue'),
                name: 'Kode Nomor Surat Edit',
            },

            {
                path: 'KonfigurasiSurat',
                component: () => import('@/components/KonfigurasiSurat/index.vue'),
                name: 'Konfigurasi Surat',
            },

            {
                path: 'KonfigurasiSurat/JenisSurat',
                component: () => import('@/components/KonfigurasiSurat/k_jenis_surat.vue'),
                name: 'Jenis Surat',
            },

            {
                path: 'KonfigurasiSurat/JenisSurat/:kode',
                component: () => import('@/components/KonfigurasiSurat/edit_k_jenis_surat.vue'),
                name: 'Jenis Surat Edit',
            },

            {
                path: 'KonfigurasiSurat/templateSurat',
                component: () => import('@/components/templateSurat/index.vue'),
                name: 'Template Surat',
            },

            {
                path: 'KonfigurasiSurat/templateSurat/:idx',
                component: () => import('@/components/templateSurat/edit.vue'),
                name: 'Template Surat Edit',
            },

            {
                path: 'KonfigurasiSurat/korektorSurat',
                component: () => import('@/components/Korektor/index.vue'),
                name: 'Korektor Surat',
            },

            {
                path: 'KonfigurasiSurat/korektorSurat/:id',
                component: () => import('@/components/Korektor/edit.vue'),
                name: 'Edit Korektor Surat',
            },

            {
                path: 'signer',
                component: () => import('@/components/Signer/index.vue'),
                name: 'Signer_Admin',
            },
            {
                path: 'signer/:idx',
                component: () => import('@/components/Signer/edit.vue'),
                name: 'Signer Edit Admin ',
            },

            //Automatic Blocking System (ABS)
            {
                path: 'GenerateABS',
                component: () => import('@/views/admindashboard/ABS/index.vue'),
                name: 'GenerateABS',
            },

            {
                path: 'ManajemenABS',
                component: () => import('@/views/admindashboard/ABS/index.vue'),
                name: 'ManajemenABS',
            },

            {
                path: 'DetailABS/:id_abs',
                component: () => import('@/views/admindashboard/ABS/DetailABS.vue'),
                name: 'DetailABS',
            },
            
            //Kustomisasi Data
            {
                path: 'KustomisasiData',
                component: () => import('@/components/kustomisasi/a_penerbitansurat.vue'),
                name: 'Kustomisasi',
            },

            {
                path: 'KustomisasiData/:kode_wb',
                component: () => import('@/views/admindashboard/KustomisasiData/ListPertahun.vue'),
                name: 'KustomisasiAdmin',
            },

            {
                path: 'KustomisasiData/Edit/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/KustomisasiData/edit.vue'),
                name: 'EditKustomisasiAdmin'
            },
            {
                path: 'Pelaporan',
                component: () => import('@/views/admindashboard/Pelaporan/index.vue'),
                name: 'pelaporan'
            },
            {
                path: 'Pelaporan/LaporanTarget',
                component: () => import('@/views/admindashboard/Pelaporan/laporan_target.vue'),
                name: 'laporantarget',
            },
            {
                path: 'Pelaporan/LaporanRealisasi',
                component: () => import('@/views/admindashboard/Pelaporan/laporan_realisasi.vue'),
                name: 'laporanrealisasi',
            },
            {
                path: 'Pelaporan/LaporanPiutang',
                component: () => import('@/views/admindashboard/Pelaporan/laporan_piutang.vue'),
                name: 'LaporanPiutang',
            },
            {
                path: 'Pelaporan/LaporanVerifikasi',
                component: () => import('@/views/admindashboard/Pelaporan/laporan_verifikasi.vue'),
                name: 'LaporanVerifikasi',
            },
            {
                path: 'Pelaporan/TargetProvinsi',
                component: () => import('@/views/admindashboard/Pelaporan/target_provinsi.vue'),
                name: 'TargetProvinsi',
            },
            {
                path: 'Pelaporan/LaporanPiutangV2',
                component: () => import('@/views/admindashboard/Pelaporan/laporan_piutang_v2.vue'),
                name: 'LaporanPiutangV2ADM',
            },
            {
                path: 'Pelaporan/TargetProvinsi',
                component: () => import('@/views/admindashboard/Pelaporan/target_provinsi.vue'),
                name: 'TargetProvinsiADM',
            },
            //Verifikasi Pembayaran
            {
                path: 'verifikasiadmin/:kode',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/list_verifikasi.vue'),
                name: 'VerifikasiKode',
            },
            {
                path: 'Verifikasi_Pembayaran',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/index.vue'),
                name: 'VerifikasiPembayaran',
            },

            {
                path: 'Verifikasi_Pembayaran/Tambah_Verifikasi',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/tambah_verifikasi.vue'),
                name: 'TambahVerifikasi',
            },
            {
                path: 'Verifikasi_Pembayaran/Edit/:kode/:tahun',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/EditDataVerifikasi.vue'),
                name: 'EditVerifikasi',
            },
            {
                path: 'VerifikasiPembayaran/BatalKegiatan/:kode',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/BatalValidasi.vue'),
                name: 'BatalValidasi',
            },
            {
                path: 'DaftarRencana/:kode',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/daftar_kegiatan.vue'),
                name: 'DaftarRencanaVerifikasi',
                props: true,
            },
            {
                path: 'HasilVerifikasi/:kode_verifikasi/:tahun/:kode_wb',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/Hasil_verifikasi.vue'),
                name: 'HasilVerifikasi',
            },
            {
                path: 'HasilVerifikasiV1/:kode_wb',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/InputVerifikasiLegacy.vue'),
                name: 'HasilVerifikasiV1ADM',
            },
            
            // Pembayaran Obsolete
            {
                path: 'Pembayaran/DashboardPembayaranSimponi',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranSimponi/index.vue'),
                name: 'DashboardSimponi',
            },

            //Pembayaran Angsur
            {
                path: 'Pembayaran/Angsur',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/index-angsur.vue'),
                name: 'Pembayaran Angsur',
            },

            {
                path: 'Pembayaran/Pengangsuran/:kode_wb/:tahun/:idx',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/index.vue'),
                name: 'Pengangsuran Detail',
            },

            {
                path: 'Pembayaran/Pengangsuran/Permohonan/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/TambahPermohonan.vue'),
                name: 'Tambah Permohonan',
            },

            {
                path: 'Pembayaran/Pengangsuran/Tambah_Persetujuan/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/TambahPersetujuan.vue'),
                name: 'Tambah Persetujuan',
            },

            {
                path: 'Pembayaran/Pengangsuran/Tambah_Data_Angsur/:kode_wb/:tahun/:idx',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranAngsur/TambahDataRencanaPengangsuran.vue'),
                name: 'Tambah Rencana Pengangsuran',
            },

            //Pembayaran KPKNL
            {
                path: 'Pembayaran/SKKPKNL',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/TampilSK.vue'),
                name: 'SKKPKNL'
            },
            {
                path: 'Pembayaran/KPKNL/:kode_wb',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/index-kpknl.vue'),
                name: 'PembayaranKPKNL'
            },
            {
                path: 'Pembayaran/KPKNL/detail/:kode_wb/:thn',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/index.vue'),
                name: 'PembayaranKpknlDetail'
            },
            {
                path: 'Pembayaran/KPKNL/TambahDataPembayaran/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/TambahDataPembayaran.vue'),
                name: 'Tambah Data Pembayaran',
            },
            {
                path: 'Pembayaran/KPKNL/TambahSP3N/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/EditSP3N.vue'),
                name: 'EditDataSP3N',
            },
            {
                path: 'Pembayaran/KPKNL/CrashProgram/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/CrashProgram.vue'),
                name: 'CrashProgram',
            },
            {
                path: 'Pembayaran/KPKNL/Tambah_SPUPN/:kode_wb/:tahun',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/penyerahan.vue'),
                name: 'Tambah SPUPN',
            },
            {
                path: 'EditPembayaran/KPKNL/:idx',
                component: () => import('@/views/admindashboard/pembayaran/PembayaranKPKNL/EditDataPembayaran.vue'),
                name: 'Edit Pembayaran',
            },

            //Persuratan
            {
                path: 'Persuratan/DashboardSuratOnline',
                component: () => import('@/views/admindashboard/DashboardSuratOnline/index.vue'),
                name: 'DashboardSuratOnline',
            },

            {
                path: 'Persuratan/DaftarKonsepSurat',
                component: () => import('@/views/admindashboard/DaftarKonsepSurat/index.vue'),
                name: 'DaftarKonsepSurat',
            },

            {
                path: 'Persuratan/DaftarKonsepSurat/Tambah',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                name: 'TambahKonsepSurat',
            },
            {
                path: 'Persuratan/DaftarKonsepSurat/:idx',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/admindashboard/DaftarKonsepSurat/edit.vue'),
                name: 'EditKonsepSurat',
            },
            {
                path: 'Persuratan/DaftarSuratDigital',
                component: () => import('@/views/admindashboard/DaftarSuratDigital/index.vue'),
                name: 'DaftarSuratDigital',
            },

            ///KorektorSuratBerjenjang
            {
                path: 'Persuratan/FiturKoreksiSuratBerjenjang',
                component: () => import('@/views/admindashboard/DaftarSuratDigital/index.vue'),
                name: 'DaftarSuratDigital',
            },

            //Route Baseline
            {
                path: 'Baseline/:kode_wb',
                component: () => import('@/views/admindashboard/Baseline/DaftarBaseline.vue'),
                name: 'DaftarAdminBaseline',
            },
            {
                path: 'BaselineNew/:kode_wb',
                component: () => import('@/views/admindashboard/Baseline/Baseline.vue'),
                name: 'AdminBaseline',
            },
            {
                path: 'Baseline/DetailBaseline/:kode_wb/:id_baseline',
                component: () => import('@/views/admindashboard/Baseline/DetailBaseline2.vue'),
                name: 'AdminDetailBaseline',
            },
            {
                path: 'Baseline/DetailBaselineT0/:kode_wb/:id_baseline',
                component: () => import('@/views/admindashboard/Baseline/DetailBaselineT0.vue'),
                name: 'AdminDetailBaselineT0',
            },
            {
                path: 'Baseline/DetailBaselinePertahun/:kode_wb/:id_baseline',
                component: () => import('@/views/admindashboard/Baseline/DetailBaselinePertahun.vue'),
                name: 'AdminDetailBaselinePertahun',
            },
            {
                path: 'JenisTarif',
                component: () => import('@/views/admindashboard/Baseline/JenisTarif.vue'),
                name: 'AdminJenisTarif',
            },
            {
                path: 'JenisArealTerganggu',
                component: () => import('@/views/admindashboard/Baseline/JenisArealTerganggu.vue'),
                name: 'AdminJenisArealTerganggu',
            },
            //Route Piutang
            {
                path: 'Piutang/:kode_wb',
                component: () => import('@/views/admindashboard/Piutang/DaftarPiutang.vue'),
                name: 'DaftarAdminPiutang',
            },
            {
                path: 'Piutang/Detail/:kode_wb/:thn',
                component: () => import('@/views/admindashboard/Piutang/DetailPiutang.vue'),
                name: 'DetailAdminPiutang',
            },
            //Route Profil
            // {
            //     path: 'Profil/:kode_wb',
            //     component: () => import('@/views/admindashboard/Profil/ProfilPPKH.vue'),
            //     name: 'AdminProfil',
            // },

            //Route manajemen user
            {
                path: 'DaftarUser',
                component: () => import('@/views/admindashboard/User/DaftarUser.vue'),
                name: 'AdminDaftarUser',
            },
            {
                path: 'DetailUser/:id',
                component: () => import('@/views/admindashboard/User/DetailUser.vue'),
                name: 'AdminDetailUser',
            },
            {
                path: 'Roles',
                component: () => import('@/views/admindashboard/User/Roles.vue'),
                name: 'AdminRoles',
            },
            {
                path: 'Features',
                component: () => import('@/views/admindashboard/User/Features.vue'),
                name: 'AdminFeatures',
            },
            {
                path: 'Menus',
                component: () => import('@/views/admindashboard/User/Menus.vue'),
                name: 'AdminMenus',
            },
            {
                path: 'RoleFeatures',
                component: () => import('@/views/admindashboard/User/RoleFeatures.vue'),
                name: 'AdminRoleFeatures',
            },
            {
                path: 'FeatureMenu',
                component: () => import('@/views/admindashboard/User/FeatureMenu.vue'),
                name: 'AdminFeatureMenu',
            },
            //Route daftar konsultasi
            {
                path: 'DaftarKonsultasi',
                component: () => import('@/views/admindashboard/Konsultasi/DaftarKonsultasi.vue'),
                name: 'AdminDaftarKonsultasi',
            },
            {
                path: 'DaftarPokja',
                component: () => import('@/views/admindashboard/Konsultasi/DaftarPokja.vue'),
                name: 'DaftarPokja',
            },
            {
                path: 'DaftarSubyek',
                component: () => import('@/views/admindashboard/Konsultasi/DaftarSubyek.vue'),
                name: 'DaftarSubyek',
            },
            {
                path: 'EditKonsultasi/:idx',
                component: () => import('@/views/admindashboard/Konsultasi/EditKonsultasi.vue'),
                name: 'AdminEditKonsultasi',
            },
            //Modul Manajemen Pekerjaan
            {
                path: 'ManageJob',
                component: () => import('@/views/admindashboard/ManageJob/index.vue'),
                name: 'Manajemen Pekerjaan',
            },
            // {
            //     path: 'detailbaselines',
            //     component: () => import('@/components/Baselinemap/detailbaselines.vue'),
            //     name: 'detailbaselines',
            // },

            //Modul SOP
            {
                path: 'SOP',
                component: () => import('@/components/SOP/index.vue'),
                name: 'SOP',
            },
            {
                path: 'addSOP',
                component: () => import('@/components/SOP/addsop.vue'),
                name: 'addSOP',
            },

            {
                path: 'detailsop/:kode_sop',
                component: () => import('@/components/SOP/detailsop.vue'),
                name: 'detailSOP',
            },
            {
                path: 'flowchartsop/:kode_sop',
                component: () => import('@/components/SOP/flowchartsop.vue'),
                name: 'FlowchartSOP',
            },

            //Modul CRM Customer Relation Management
            {
                path: 'Livechat',
                component: () => import('@/views/admindashboard/Chat/LiveChat.vue'),
                name: 'LiveChatGlobal',
            },
            {
                path: 'Broadcast',
                component: () => import('@/views/admindashboard/Chat/Broadcast.vue'),
                name: 'Broadcast',
            },
            //Tanggal Libur
            {
                path: 'TanggalLibur',
                component: () => import('@/views/admindashboard/Tanggal/tanggal_libur.vue'),
                name: 'AdminTanggalLibur',
            },
            //Oper Service
            {
                path: 'OpenService',
                component: () => import('@/views/admindashboard/Service/open_service.vue'),
                name: 'AdminOpenService',
            },

            //Jenis Dokumen
            {
                path: 'JenisDokumen',
                component: () => import('@/components/Dokumen/JenisDokumen.vue'),
                name: 'AdminJenisDokumen',
            },

            //PNBP Kompensasi
            {
                path: 'PNBPKompensasi/:kode_wb',
                component: () => import('@/views/admindashboard/PNBPKompensasi/PNBPKompensasi.vue'),
                name: 'PNBPKompensasiAdmin',
            },

            //Agenda
            {
                path: 'Agenda',
                component: () => import('@/views/admindashboard/Agenda/DaftarAgenda.vue'),
                name: 'AgendaAdmin',
            },
            {
                path: 'DetailAgenda/:id',
                component: () => import('@/views/admindashboard/Agenda/DetailAgenda.vue'),
                name: 'DetailAgendaAdmin',
            },

            //Manajemen PPKH
            {
                path: 'ManajemenPPKH/:kode_wb',
                component: () => import('@/views/admindashboard/ManajemenPPKH/manajemenPPKH.vue'),
                name: 'ManajemenPPKHADM',
            },

            //Linktree Subdit PKPNBPPKH
            {
                path: 'linktree',
                component: () => import('@/views/admindashboard/Linktree/Linktree.vue'),
                name: 'LinktreeAdmin',
            },

            //Panduan aplikasi
            {
                path: 'DaftarPanduan',
                component: () => import('@/views/admindashboard/Panduan/DaftarPanduan.vue'),
                name: 'DaftarPanduanAdmin',
            },
            {
                path: 'DetailPanduan/:id',
                component: () => import('@/views/admindashboard/Panduan/DetailPanduan.vue'),
                name: 'DetailPanduanAdmin',
            },

            //Sanksi gakkum 10 kali
            // {
            //     path: 'SanksiGakkum/:kode_wb',
            //     component: () => import('@/views/admindashboard/SanksiGakkum/SanksiGakkum.vue'),
            //     name: 'SanksiGakkumADM',
            // },
        ]

    },
    {
        path: '/DirekturDashboard/',
        component: () => import('@/views/direkturdashboard/DirekturDashboard.vue'),
        name: 'DirekturDashboard',
        children: [


            {
                path: 'KonfigurasiSurat',
                component: () => import('@/components/KonfigurasiSurat/index.vue'),
                name: 'Konfigurasi Surat Direktur',
            },


            {
                path: 'KonfigurasiSurat/templateSurat',
                component: () => import('@/components/templateSurat/index.vue'),
                name: 'Template Surat Direktur',
            },

            {
                path: 'KonfigurasiSurat/templateSurat/:idx',
                component: () => import('@/components/templateSurat/edit.vue'),
                name: 'Template Surat Edit Direktur',
            },

            {
                path: 'KonfigurasiSurat/korektorSurat',
                // component: ()=> import('@/components/KonfigurasiSurat/korektor.vue'),
                component: () => import('@/components/Korektor/index.vue'),
                name: 'Korektor Surat Direktur',
            },

            {
                path: 'KonfigurasiSurat/korektorSurat/:id',
                // component: ()=> import('@/components/KonfigurasiSurat/korektor.vue'),
                component: () => import('@/components/Korektor/edit.vue'),
                name: 'Edit Korektor Surat Direktur',
            },


            {
                path: 'signer',
                component: () => import('@/components/Signer/index.vue'),
                // name:'TTD_Surat',
                name: 'Signer_Direktur',
            },

            {
                path: 'Persuratan/DashboardSuratOnline',
                component: () => import('@/views/direkturdashboard/DashboardSuratOnline/index.vue'),
                name: 'DashboardSuratOnlineDirektur',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat',
                component: () => import('@/views/direkturdashboard/DaftarKonsepSurat/index.vue'),
                name: 'DaftarKonsepSuratDirektur',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat/:idx',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/direkturdashboard/DaftarKonsepSurat/edit.vue'),
                name: 'EditKonsepSuratDirektur',
            },

            {
                path: 'ttdSurat',
                component: () => import('@/components/ttdsurat/index.vue'),
                // name:'TTD_Surat',
                name: 'TTD_Surat_Direktur',
            },

            {
                path: 'ttdSurat/:idx',
                component: () => import('@/components/ttdsurat/preview.vue'),
                // name:'TTD_Surat',
                name: 'TTD_Surat_preview_Direktur',
            },


            // {
            //     path: 'KirimSurat',
            //     component: () => import('@/components/kirimsurat/index.vue'),
            //     name: 'NomorSuratDirektur',
            // },

            // {
            //     path: 'SuratTelahKirim',
            //     component: () => import('@/components/kirimsurat/index_telah.vue'),
            //     name: 'Surat Telah Kirim Direktur',
            // },


            {
                path: 'korektor_surat',
                component: () => import('@/components/Korektor/index.vue'),
                // name:'TTD_Surat',
                name: 'Korektor_Surat_Direktur',
            },

            {
                path: 'korektor_surat/:id',
                component: () => import('@/components/Korektor/edit.vue'),
                // name:'TTD_Surat',
                name: 'Korektor_Surat_id_Direktur',
            },



            {
                path: 'surat',
                component: () => import('@/components/Surat/index.vue'),
                // name:'TTD_Surat',
                name: 'Surat_Direktur',
            },

            {
                path: 'pilih_kode_surat',
                component: () => import('@/components/Surat/pilih_kode.vue'),
                // name:'TTD_Surat',
                name: 'Pilih Kode Surat Direktur',
            },

            {
                path: 'kodeNomorSurat',
                // component: ()=> import('@/components/ttdsurat/m_number.vue'),
                component: () => import('@/components/KodeNomorSurat/index.vue'),
                name: 'Kode surat direktur',
            },

            ///KorektorSuratBerjenjang
            {
                path: 'Persuratan/FiturKoreksiSuratBerjenjang',
                component: () => import('@/views/direkturdashboard/DaftarSuratDigital/index.vue'),
                name: 'DaftarSuratDigitalDirektur',
            },

            //Route manajemen user
            // {
            //     path: 'DaftarUser',
            //     component: () => import('@/views/admindashboard/User/DaftarUser.vue'),
            //     name: 'DirDaftarUser',
            // },
            // {
            //     path: 'DetailUser/:id',
            //     component: () => import('@/views/admindashboard/User/DetailUser.vue'),
            //     name: 'DirDetailUser',
            // },
        ]
    },
    {
        path: '/KasubditDashboard/',
        component: () => import('@/views/kasubditdashboard/KasubditDashboard.vue'),
        name: 'KasubditDashboard',
        children: [
            {
                path: '',
                component: () => import('@/views/kasubditdashboard/Dashboard.vue'),
                name: 'KSBDDashboard',


            },
            {
                path: 'Persuratan/DashboardSuratOnline',
                component: () => import('@/views/kasubditdashboard/DashboardSuratOnline/index.vue'),
                name: 'DashboardSuratOnlineKasubdit',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat',
                component: () => import('@/views/kasubditdashboard/DaftarKonsepSurat/index.vue'),
                name: 'DaftarKonsepSuratKasubdit',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat/Tambah',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/kasubditdashboard/DaftarKonsepSurat/tambah.vue'),
                name: 'TambahKonsepSuratKasubdit',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat/:idx',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/kasubditdashboard/DaftarKonsepSurat/edit.vue'),
                name: 'EditKonsepSuratKasubdit',
            },

            {
                path: 'Persuratan/DaftarSuratDigital',
                component: () => import('@/views/kasubditdashboard/DaftarSuratDigital/index.vue'),
                name: 'DaftarSuratDigitalKasubdit',
            },

            //Route manajemen user
            // {
            //     path: 'DaftarUser',
            //     component: () => import('@/views/admindashboard/User/DaftarUser.vue'),
            //     name: 'KasubditDaftarUser',
            // },
            // {
            //     path: 'DetailUser/:id',
            //     component: () => import('@/views/admindashboard/User/DetailUser.vue'),
            //     name: 'KasubditDetailUser',
            // },

        ]

    },
    {
        path: '/KapokjaDashboard/',
        component: () => import('@/views/kapokjadashboard/Kapokja.vue'),
        name: 'StaffKapokja',
        children: [
            {
                path: '',
                component: () => import('@/views/kapokjadashboard/Dashboard.vue'),
                name: 'kapokja'
            },

            {
                path: 'FormulirSKPPKH',
                component: () => import('@/views/kapokjadashboard/Skppkh.vue'),
                name: 'formulirskapokja',
            },

            {
                path: 'FormulirSKPPKH/detail/:kode_wb',
                // component: ()=> import('@/views/wajibbayardashboard/WajibBayarSkppkh-detail.vue'),
                component: () => import('@/views/kapokjadashboard/MenuUtamaPPKH.vue'),
                name: 'MenuUtamaKapokja',
            },

             //Pembayaran Normal
             {
                path: 'pembayaran/:kode_wb',
                component: () => import('@/views/kapokjadashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranKode.vue'),
                name: 'PembayaranKapokjaKode'
            },

             {
                path: 'pembayaran_rinci/:kode_wb/:thn',
                component: () => import('@/views/kapokjadashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranRinci.vue'),
                name: 'PembayaranKapokjaRinci',
            },

            {
                path: 'invoice_pembayaran/:idx',
                component: () => import('@/views/kapokjadashboard/pembayaran/MenuUtamaPembayaran/Invoice_Pembayaran_dua.vue'),
                name: 'InvoiceBillingKapokjaDetail',
            },

            {
                path: 'PembayaranLunas/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/pembayaran/MenuUtamaPembayaran/telahDibayar.vue'),
                name: 'PembayaranLunasKapokja',
            },

            //Pembayaran KPKNL
            {
                path: 'Pembayaran/SKKPKNL',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/TampilSK.vue'),
                name: 'SKKPKNLKapokja'
            },
            {
                path: 'Pembayaran/KPKNL/:kode_wb',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/index-kpknl.vue'),
                name: 'PembayaranKPKNLKapokja'
            },
            {
                path: 'Pembayaran/KPKNL/detail/:kode_wb/:thn',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/index.vue'),
                name: 'PembayaranKpknlDetailKapokja'
            },
            {
                path: 'Pembayaran/KPKNL/TambahDataPembayaran/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/TambahDataPembayaran.vue'),
                name: 'Tambah Data Pembayaran Kapokja',
            },
            {
                path: 'Pembayaran/KPKNL/TambahSP3N/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/EditSP3N.vue'),
                name: 'EditDataSP3NKapokja',
            },
            {
                path: 'Pembayaran/KPKNL/CrashProgram/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/CrashProgram.vue'),
                name: 'CrashProgramKapokja',

            },
            {
                path: 'Pembayaran/KPKNL/Tambah_SPUPN/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/penyerahan.vue'),
                name: 'Tambah SPUPN Kapokja',
            },
            {
                path: 'EditPembayaran/KPKNL/:idx',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranKPKNL/EditDataPembayaran.vue'),
                name: 'Edit Pembayaran Kapokja',
            },

            //Pembayaran Angsur
            {
                path: 'Pembayaran/Angsur',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranAngsur/index-angsur.vue'),
                name: 'Pembayaran Angsur Kapokja',
            },

            {
                path: 'Pembayaran/Pengangsuran/:kode_wb/:tahun/:idx',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranAngsur/index.vue'),
                name: 'Pengangsuran Detail Kapokja',
            },

            {
                path: 'Pembayaran/Pengangsuran/Permohonan/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranAngsur/TambahPermohonan.vue'),
                name: 'Tambah Permohonan Kapokja',
            },
            
            {
                path: 'Pembayaran/Pengangsuran/Tambah_Persetujuan/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranAngsur/TambahPersetujuan.vue'),
                name: 'Tambah Persetujuan Kapokja',
            },

            {
                path: 'Pembayaran/Pengangsuran/Tambah_Data_Angsur/:kode_wb/:tahun/:idx',
                component: () => import('@/views/kapokjadashboard/pembayaran/PembayaranAngsur/TambahDataRencanaPengangsuran.vue'),
                name: 'Tambah Rencana Pengangsuran Kapokja',
            },

            //baseline
            {
                path: 'Baseline/:kode_wb',
                component: () => import('@/views/kapokjadashboard/Baseline/DaftarBaseline.vue'),
                name: 'DaftarBaselineKapokja',
            },

            //Piutang
            {
                path: 'Piutang/:kode_wb',
                component: () => import('@/views/kapokjadashboard/Piutang/DaftarPiutang.vue'),
                name: 'DaftarPiutangKapokja',
            },
            {
                path: 'Piutang/Detail/:kode_wb/:thn',
                component: () => import('@/views/kapokjadashboard/Piutang/DetailPiutang.vue'),
                name: 'DetailPiutangKapokja',
            },

            //Persuratan
            {
                path: 'Persuratan/:kode_wb',
                component: () => import('@/views/kapokjadashboard/Persuratan/index.vue'),
                name: 'PersuratanKapokja',
            },
            //Kustomisasi Menu

            {
                path: 'KustomisasiData/:kode_wb',
                component: () => import('@/views/kapokjadashboard/KustomisasiData/ListPertahun.vue'),
                name: 'KustomisasiKapokja',
            },

            {
                path: 'KustomisasiData/Edit/:kode_wb/:tahun',
                component: () => import('@/views/kapokjadashboard/KustomisasiData/edit.vue'),
                name: 'EditKustomisasiKapokja'
            },

            //End Kustomisasi
            
            {
                path: 'Persuratan/DashboardSuratOnline',
                component: () => import('@/views/kapokjadashboard/DashboardSuratOnline/index.vue'),
                name: 'DashboardSuratOnlineKapokja',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat',
                component: () => import('@/views/kapokjadashboard/DaftarKonsepSurat/index.vue'),
                name: 'DaftarKonsepSuratKapokja',
            },

            {
                path: 'Persuratan/DaftarKonsepSurat/Tambah',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/kapokjadashboard/DaftarKonsepSurat/tambah.vue'),
                name: 'TambahKonsepSuratKapokja',
            },

            {
                path: 'Persuratan/DaftarKonsepSurat/:idx',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/kapokjadashboard/DaftarKonsepSurat/edit.vue'),
                name: 'EditKonsepSuratKapokja',
            },

            {
                path: 'Persuratan/DaftarSuratDigital',
                component: () => import('@/views/kapokjadashboard/DaftarSuratDigital/index.vue'),
                name: 'DaftarSuratDigitalKapokja',
            },

            //Setup Kegiatan verifikasi 
            {
                path: 'verifikasi/:kode',
                component: () => import('@/views/kapokjadashboard/VerifikasiPembayaran/list_verifikasi.vue'),
                name: 'VerifikasiKodekapokja',
            },

            {
                path: 'VerifikasiPembayaran',
                component: () => import('@/views/kapokjadashboard/VerifikasiPembayaran/index.vue'),
                name: 'VerifikasiPembayaranKapokja',
            },
            {
                path: 'Verifikasi_Pembayaran/TambahVerifikasi',
                component: () => import('@/views/kapokjadashboard/VerifikasiPembayaran/tambah_verifikasi.vue'),
                name: 'TambahVerifikasiKapokja',
            },
            {
                path: 'Verifikasi_Pembayaran/Edit/:kode/:tahun',
                component: () => import('@/views/kapokjadashboard/VerifikasiPembayaran/EditDataVerifikasi.vue'),
                name: 'EditVerifikasikapokja',
            },
            {
                path: 'DaftarRencana/:kode',
                component: () => import('@/views/kapokjadashboard/VerifikasiPembayaran/daftar_kegiatan.vue'),
                name: 'DaftarRencanaVerifikasikapokja',
                props: true,
            },
            {
                path: 'VerifikasiPembayaran/BatalKegiatan/:kode',
                component: () => import('@/views/kapokjadashboard/VerifikasiPembayaran/BatalValidasi.vue'),
                name: 'BatalValidasikapokja',
            },

            {
                path: 'HasilVerifikasi/:kode_verifikasi/:tahun/:kode_wb',
                component: () => import('@/views/kapokjadashboard/VerifikasiPembayaran/Hasil_verifikasi.vue'),
                name: 'HasilVerifikasikapokja',
            },

            //Route manajemen user
            {
                path: 'DaftarUser',
                component: () => import('@/views/kapokjadashboard/User/DaftarUser.vue'),
                name: 'KapokjaDaftarUser',
            },
            {
                path: 'DetailUser/:id',
                component: () => import('@/views/kapokjadashboard/User/DetailUser.vue'),
                name: 'KapokjaDetailUser',
            },

            //Tanggal Libur
            {
                path: 'TanggalLibur',
                component: () => import('@/views/kapokjadashboard/Tanggal/tanggal_libur.vue'),
                name: 'KapokjaTanggalLibur',
            },

            //Routing untuk Laporan Feature
            {
                path: 'Pelaporan',
                component: () => import('@/views/kapokjadashboard/Pelaporan/index.vue'),
                name: 'LaporanKapokja'
            },
            {
                path: 'Pelaporan/LaporanTarget',
                component: () => import('@/views/kapokjadashboard/Pelaporan/laporan_target.vue'),
                name: 'LaporanTargetKapokja',
            },
            {
                path: 'Pelaporan/LaporanRealisasi',
                component: () => import('@/views/kapokjadashboard/Pelaporan/laporan_realisasi.vue'),
                name: 'LaporanRealisasiKapokja',
            },
            {
                path: 'Pelaporan/LaporanPiutang',
                component: () => import('@/views/kapokjadashboard/Pelaporan/laporan_piutang.vue'),
                name: 'LaporanPiutangKapokja',
            },
            {
                path: 'Pelaporan/LaporanVerifikasi',
                component: () => import('@/views/kapokjadashboard/Pelaporan/laporan_verifikasi.vue'),
                name: 'LaporanVerifikasiKapokja',
            },


        ]
    },
    {
        path: '/StaffOperator/',
        component: () => import('@/views/operatordashboard/StaffOperator.vue'),
        name: 'StaffOperatorDashboard',
        children: [
            //dipakai
            {
                path: '',
                // component: () => import ('@/views/dashboard/MenuUtama.vue'),
                component: () => import('@/views/wajibbayardashboard/Dashboard.vue'),
                name: 'OperatorDashboard'
            },
            //dipakai
            {
                path: 'FormulirSKPPKH',
                component: () => import('@/views/operatordashboard/OperatorFormSK.vue'),
                name: 'formulirskoperator',
            },

            //dipakai
            {
                path: 'FormulirSKPPKH/MenuUtama/:kode_wajib_bayar',
                component: () => import('@/views/operatordashboard/MenuUtamaPPKH.vue'),
                name: 'formuliroperatorskdetail',
            },

            //Pembayaran Normal
            {
                path: 'pembayaran/:kode_wb',
                component: () => import('@/views/operatordashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranKode.vue'),
                name: 'PembayaranOperatorKode'
            },

            {
                path: 'pembayaran_rinci/:kode_wb/:thn',
                component: () => import('@/views/operatordashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranRinci.vue'),
                name: 'PembayaranoperatorRinci',
            },

            {
                path: 'invoice_pembayaran/:idx',
                component: () => import('@/views/operatordashboard/pembayaran/MenuUtamaPembayaran/Invoice_Pembayaran_dua.vue'),
                name: 'InvoiceBillingOperatorDetail',
            },

            {
                path: 'PembayaranLunas/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/pembayaran/MenuUtamaPembayaran/telahDibayar.vue'),
                name: 'PembayaranLunasOPR',
            },

            //Pembayaran KPKNL
            {
                path: 'KPKNL/:kode_wb/:thn',
                component: () => import('@/views/operatordashboard/PembayaranKPKNL/index.vue'),
                name: 'KpknlDetailOperator'
            },
            {
                path: 'Pembayaran/SKKPKNL',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/TampilSK.vue'),
                name: 'SKKPKNLOperator'
            },
            {
                path: 'Pembayaran/KPKNL/:kode_wb',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/index-kpknl.vue'),
                name: 'PembayaranKPKNLOperator'
            },
            {
                path: 'Pembayaran/KPKNL/detail/:kode_wb/:thn',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/index.vue'),
                name: 'PembayaranKpknlDetailOperator'
            },
            {
                path: 'Pembayaran/KPKNL/TambahDataPembayaran/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/TambahDataPembayaran.vue'),
                name: 'Tambah Data Pembayaran Operator',
            },
            {
                path: 'Pembayaran/KPKNL/TambahSP3N/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/EditSP3N.vue'),
                name: 'EditDataSP3NOperator',
            },
            {
                path: 'Pembayaran/KPKNL/CrashProgram/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/CrashProgram.vue'),
                name: 'CrashProgramOperator',

            },
            {
                path: 'Pembayaran/KPKNL/Tambah_SPUPN/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/penyerahan.vue'),
                name: 'Tambah SPUPN Operator',
            },
            {
                path: 'EditPembayaran/KPKNL/:idx',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranKPKNL/EditDataPembayaran.vue'),
                name: 'Edit Pembayaran Operator',
            },

            //Pembayaran Angsur
            {
                path: 'Pembayaran/Angsur',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranAngsur/index-angsur.vue'),
                name: 'Pembayaran Angsur Operator',
            },

            {
                path: 'Pembayaran/Pengangsuran/:kode_wb/:tahun/:idx',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranAngsur/index.vue'),
                name: 'Pengangsuran Detail Operator',
            },

            {
                path: 'Pembayaran/Pengangsuran/Permohonan/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranAngsur/TambahPermohonan.vue'),
                name: 'Tambah Permohonan Operator',
            },
            
            {
                path: 'Pembayaran/Pengangsuran/Tambah_Persetujuan/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranAngsur/TambahPersetujuan.vue'),
                name: 'Tambah Persetujuan Operator',
            },

            {
                path: 'Pembayaran/Pengangsuran/Tambah_Data_Angsur/:kode_wb/:tahun/:idx',
                component: () => import('@/views/operatordashboard/pembayaran/PembayaranAngsur/TambahDataRencanaPengangsuran.vue'),
                name: 'Tambah Rencana Pengangsuran Operator',
            },

            //baseline
            {
                path: 'Baseline/:kode_wb',
                component: () => import('@/views/operatordashboard/Baseline/DaftarBaseline.vue'),
                name: 'DaftarOprBaseline',
            },
            {
                path: 'BaselineNew/:kode_wb',
                component: () => import('@/views/operatordashboard/Baseline/Baseline.vue'),
                name: 'OprBaseline',
            },
            {
                path: 'Baseline/DetailBaseline/:kode_wb/:id_baseline',
                component: () => import('@/views/operatordashboard/Baseline/DetailBaseline2.vue'),
                name: 'OprDetailBaseline',
            },
            {
                path: 'Baseline/DetailBaselineT0/:kode_wb/:id_baseline',
                component: () => import('@/views/operatordashboard/Baseline/DetailBaselineT0.vue'),
                name: 'OprDetailBaselineT0',
            },
            {
                path: 'Baseline/DetailBaselinePertahun/:kode_wb/:id_baseline',
                component: () => import('@/views/operatordashboard/Baseline/DetailBaselinePertahun.vue'),
                name: 'OprDetailBaselinePertahun',
            },

            //Piutang
            {
                path: 'Piutang/:kode_wb',
                component: () => import('@/views/operatordashboard/Piutang/DaftarPiutang.vue'),
                name: 'DaftarOperatorPiutang',
            },
            {
                path: 'Piutang/Detail/:kode_wb/:thn',
                component: () => import('@/views/operatordashboard/Piutang/DetailPiutang.vue'),
                name: 'DetailOperatorPiutang',
            },

            //menu utama persuratan
            {
                path: 'Persuratan/:kode_wb',
                component: () => import('@/views/operatordashboard/Persuratan/index.vue'),
                name: 'OperatorPersuratan',
            },

            /// Persuratan
            {
                path: 'Persuratan/DashboardSuratOnline',
                component: () => import('@/views/operatordashboard/DashboardSuratOnline/index.vue'),
                name: 'DashboardSuratOnlineOperator',
            },

            {
                path: 'Persuratan/DaftarKonsepSurat',
                component: () => import('@/views/operatordashboard/DaftarKonsepSurat/index.vue'),
                name: 'DaftarKonsepSuratOperator',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat/Tambah',
                component: () => import('@/views/operatordashboard/DaftarKonsepSurat/tambah.vue'),
                name: 'TambahKonsepSuratOperator',
            },


            {
                path: 'Persuratan/DaftarKonsepSurat/:idx',
                // component : ()=> import('@/views/admindashboard/DaftarKonsepSurat/tambah.vue'),
                component: () => import('@/views/operatordashboard/DaftarKonsepSurat/edit.vue'),
                name: 'EditKonsepSuratOperator',
            },

            {
                path: 'Persuratan/DaftarSuratDigital',
                component: () => import('@/views/operatordashboard/DaftarSuratDigital/index.vue'),
                name: 'DaftarSuratDigitalOperator',
            },

            //Setup Hasil Verifikasi 
            {
                path: 'Verifikasi_Pembayaran',
                component: () => import('@/views/operatordashboard/VerifikasiPembayaran/index.vue'),
                name: 'VerifikasiPembayaranOperator',
            },
            {
                path: 'Verifikasi_Pembayaran/TambahVerifikasiOperator',
                component: () => import('@/views/operatordashboard/VerifikasiPembayaran/tambah_verifikasi.vue'),
                name: 'TambahVerifikasiOperator',
            },
            {
                path: 'Verifikasi_Pembayaran/Edit/:kode/:tahun',
                component: () => import('@/views/operatordashboard/VerifikasiPembayaran/EditDataVerifikasi.vue'),
                name: 'EditVerifikasiOperator',
            },
            {
                path: 'DaftarRencana/:kode',
                component: () => import('@/views/operatordashboard/VerifikasiPembayaran/daftar_kegiatan.vue'),
                name: 'DaftarRencanaVerifikasiOperator',
                props: true,
            },
            {
                path: 'VerifikasiPembayaran/BatalKegiatan/:kode',
                component: () => import('@/views/operatordashboard/VerifikasiPembayaran/BatalValidasi.vue'),
                name: 'BatalValidasiOperator',
            },

            {
                path: 'HasilVerifikasi/:kode_verifikasi/:tahun/:kode_wb',
                component: () => import('@/views/operatordashboard/VerifikasiPembayaran/Hasil_verifikasi.vue'),
                name: 'HasilVerifikasiOperator',
            },

            {
                path: 'KustomisasiData/:kode_wb',
                component: () => import('@/views/operatordashboard/KustomisasiData/ListPertahun.vue'),
                name: 'KustomisasiOperator',
            },

            {
                path: 'KustomisasiData/Edit/:kode_wb/:tahun',
                component: () => import('@/views/operatordashboard/KustomisasiData/edit.vue'),
                name: 'EditKustomisasiOperator'
            },
            {
                path: 'HasilVerifikasiV1/:kode_wb',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/InputVerifikasiLegacy.vue'),
                name: 'HasilVerifikasiV1OPR',
            },
            //Route manajemen user
            {
                path: 'DaftarUser',
                component: () => import('@/views/operatordashboard/User/DaftarUser.vue'),
                name: 'StaffDaftarUser',
            },
            {
                path: 'DetailUser/:id',
                component: () => import('@/views/operatordashboard/User/DetailUser.vue'),
                name: 'StaffDetailUser',
            },

            //Route daftar konsultasi
            {
                path: 'DaftarKonsultasi',
                component: () => import('@/views/operatordashboard/Konsultasi/DaftarKonsultasi.vue'),
                name: 'OperatorDaftarKonsultasi',
            },
            {
                path: 'EditKonsultasi/:idx',
                component: () => import('@/views/operatordashboard/Konsultasi/EditKonsultasi.vue'),
                name: 'OperatorEditKonsultasi',
            },

            //Tanggal Libur
            {
                path: 'TanggalLibur',
                component: () => import('@/views/operatordashboard/Tanggal/tanggal_libur.vue'),
                name: 'OperatorTanggalLibur',
            },

            //Routing untuk Laporan Feature
            {
                path: 'Pelaporan',
                component: () => import('@/views/operatordashboard/Pelaporan/index.vue'),
                name: 'LaporanOperator'
            },
            {
                path: 'Pelaporan/LaporanTarget',
                component: () => import('@/views/operatordashboard/Pelaporan/laporan_target.vue'),
                name: 'LaporanTargetOperator',
            },
            {
                path: 'Pelaporan/LaporanRealisasi',
                component: () => import('@/views/operatordashboard/Pelaporan/laporan_realisasi.vue'),
                name: 'LaporanRealisasiOperator',
            },
            {
                path: 'Pelaporan/LaporanPiutang',
                component: () => import('@/views/operatordashboard/Pelaporan/laporan_piutang.vue'),
                name: 'LaporanPiutangOperator',
            },
            {
                path: 'Pelaporan/LaporanVerifikasi',
                component: () => import('@/views/operatordashboard/Pelaporan/laporan_verifikasi.vue'),
                name: 'LaporanVerifikasiOperator',
            },
            {
                path: 'Pelaporan/LaporanPiutangV2',
                component: () => import('@/views/admindashboard/Pelaporan/laporan_piutang_v2.vue'),
                name: 'LaporanPiutangV2OPR',
            },
            //Manajemen PPKH
            {
                path: 'ManajemenPPKH/:kode_wb',
                component: () => import('@/views/operatordashboard/ManajemenPPKH/manajemenPPKH.vue'),
                name: 'ManajemenPPKHOPR',
            },
        ]
    },
    {
        path: '/KPKNL/',
        component: () => import('@/views/kpknldashboard/KPKNLDashboard.vue'),
        name: 'KPKNLDashboard',
        children: [
            {
                path: '',
                component: () => import('@/views/kpknldashboard/Dashboard.vue'),
                name: 'kpknldashboard'
            },

            {
                path: 'FormulirSKPPKH',
                component: () => import('@/views/kpknldashboard/KPKNLSkppkh.vue'),
                name: 'formulirskkpknl',
            },
            {
                path: 'FormulirSKPPKH/MenuUtamaPPKH/:kode_wb',
                component: () => import('@/views/kpknldashboard/MenuUtamaPPKH.vue'),
                name: 'MenuUtamaPPKHKPKNL',
            },

            //Pembayaran
            {
                path: 'FormulirSKPPKH/detail/:kode_wb',
                component: () => import('@/views/kpknldashboard/Pembayaran/MenuUtamaPembayaranKode.vue'),
                name: 'formulirkpknlkode',
            },
            {
                path: 'Pembayaran/:kode_wb/:thn',
                component: () => import('@/views/kpknldashboard/Pembayaran/index.vue'),
                name: 'PembayaranKPKNLDetail',
            },
            {
                path: 'Pembayaran/TambahCrash/:kode_wb/:tahun',
                component: () => import('@/views/kpknldashboard/Pembayaran/CrashProgram.vue'),
                name: 'TambahCrashProgramKPKNL',
            },
            {
                path: 'Pembayaran/TambahSP3N/:kode_wb/:tahun',
                component: () => import('@/views/kpknldashboard/Pembayaran/EditSP3N.vue'),
                name: 'TambahEditSP3NKPKNL',
            },
            {
                path: 'Pembayaran/Penyerahan/:kode_wb/:tahun',
                component: () => import('@/views/kpknldashboard/Pembayaran/penyerahan.vue'),
                name: 'TambahPenyerahanKPKNL',
            },
            {
                path: 'Pembayaran/TambahDataPembayaran/:kode_wb/:tahun',
                component: () => import('@/views/kpknldashboard/Pembayaran/TambahDataPembayaran.vue'),
                name: 'TambahDataPembayaranKPKNL',
            },
            {
                path: 'EditPembayaran/KPKNL/:idx',
                component: () => import('@/views/kpknldashboard/Pembayaran/EditDataPembayaran.vue'),
                name: 'Edit Pembayaran KPKNL',
            },
            {
                path: 'invoice_pembayaran/:idx',
                component: () => import('@/views/kpknldashboard/Pembayaran/Invoice_Pembayaran_dua.vue'),
                name: 'InvoiceBillingKPKNLDetail',
            },

            //baseline
            {
                path: 'Baseline/:kode_wb',
                component: () => import('@/views/kpknldashboard/Baseline/DaftarBaseline.vue'),
                name: 'DaftarKPKNLBaseline',
            },

            //Daftar SK PPKH di KPKNL
            {
                path: 'SKKPKNL',
                component: () => import('@/views/kpknldashboard/Pembayaran/TampilSK.vue'),
                name: 'KPKNLSKKPKNL'
            },

            {
                path: 'Pembayaran/:kode_wb',
                component: () => import('@/views/kpknldashboard/Pembayaran/index-kpknl.vue'),
                name: 'KPKNLPembayaranKPKNL'
            },
            {
                path: 'Pembayaran/detail/:kode_wb/:thn',
                component: () => import('@/views/kpknldashboard/Pembayaran/index.vue'),
                name: 'KPKNLPembayaranKpknlDetail'
            },

            //menu utama persuratan 
            {
                path: 'Persuratan/:kode_wb',
                component: () => import('@/views/kpknldashboard/Persuratan/index.vue'),
                name: 'KPKNLPersuratan',
            },

            {
                path: 'Piutang/:kode_wb',
                component: () => import('@/views/kpknldashboard/Piutang/DaftarPiutang.vue'),
                name: 'DaftarKPKNLPiutang',
            },
            {
                path: 'Piutang/Detail/:kode_wb/:thn',
                component: () => import('@/views/kpknldashboard/Piutang/DetailPiutang.vue'),
                name: 'DetailKPNLPiutang',
            },

            //Route manajemen user
            {
                path: 'DaftarUser',
                component: () => import('@/views/kpknldashboard/User/DaftarUser.vue'),
                name: 'KpknlDaftarUser',
            },
            {
                path: 'DetailUser/:id',
                component: () => import('@/views/kpknldashboard/User/DetailUser.vue'),
                name: 'KpknlDetailUser',
            },

        ]
    },
    {
        path: '/BPKH/',
        component: () => import('@/views/BPKHDashboard/BPKHDashboard.vue'),
        name: 'BPKHDashboard1',
        children: [
            {
                path: '',
                // component: () => import ('@/views/dashboard/MenuUtama.vue'),
                component: () => import('@/views/BPKHDashboard/Dashboard.vue'),
                name: 'BPKHDashboard',
                // name: 'BPKH',
            },
            {
                path: 'FormulirSKPPKH',
                component: () => import('@/views/BPKHDashboard/Skppkh.vue'),
                name: 'formulirskBPKH',
            },
            {
                path: 'FormulirSKPPKH/detail/:kode_wb',
                // component: ()=> import('@/views/wajibbayardashboard/WajibBayarSkppkh-detail.vue'),
                component: () => import('@/views/BPKHDashboard/MenuUtamaPPKH.vue'),
                name: 'MenuUtamaBPKH',
            },

            //Route Baseline
            {
                path: 'Baseline/:kode_wb',
                component: () => import('@/views/BPKHDashboard/Baseline/DaftarBaseline.vue'),
                name: 'DaftarBaselineBPKH',
            },
            {
                path: 'BaselineNew/:kode_wb',
                component: () => import('@/views/BPKHDashboard/Baseline/Baseline.vue'),
                name: 'BPKHBaseline',
            },
            {
                path: 'Baseline/DetailBaseline/:kode_wb/:id_baseline',
                component: () => import('@/views/BPKHDashboard/Baseline/DetailBaseline2.vue'),
                name: 'BPKHDetailBaseline',
            },
            {
                path: 'Baseline/DetailBaselineT0/:kode_wb/:id_baseline',
                component: () => import('@/views/BPKHDashboard/Baseline/DetailBaselineT0.vue'),
                name: 'BPKHDetailBaselineT0',
            },
            {
                path: 'Baseline/DetailBaselinePertahun/:kode_wb/:id_baseline',
                component: () => import('@/views/BPKHDashboard/Baseline/DetailBaselinePertahun.vue'),
                name: 'BPKHDetailBaselinePertahun',
            },

            //Route Piutang
            {
                path: 'Piutang/:kode_wb',
                component: () => import('@/views/BPKHDashboard/Piutang/DaftarPiutang.vue'),
                name: 'DaftarPiutangBPKH',
            },
            {
                path: 'Piutang/Detail/:kode_wb/:thn',
                component: () => import('@/views/BPKHDashboard/Piutang/DetailPiutang.vue'),
                name: 'DetailPiutangBPKH',
            },

            //Route Persuratan
            {
                path: 'Persuratan/:kode_wb',
                component: () => import('@/views/BPKHDashboard/Persuratan/index.vue'),
                name: 'PersuratanBPKH',
            },

            //Pembayaran Normal
            {
                path: 'pembayaran/:kode_wb',
                component: () => import('@/views/BPKHDashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranKode.vue'),
                name: 'PembayaranBPKHKode'
            },

            {
                path: 'pembayaran_rinci/:kode_wb/:thn',
                component: () => import('@/views/BPKHDashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranRinci.vue'),
                name: 'PembayaranBPKHRinci',
            },

            {
                path: 'invoice_pembayaran/:idx',
                component: () => import('@/views/BPKHDashboard/pembayaran/MenuUtamaPembayaran/Invoice_Pembayaran_dua.vue'),
                name: 'InvoiceBillingBPKHDetail',
            },

            {
                path: 'PembayaranLunas/:kode_wb/:tahun',
                component: () => import('@/views/BPKHDashboard/pembayaran/MenuUtamaPembayaran/telahDibayar.vue'),
                name: 'PembayaranLunasBPKH',
            },

            //Pembayaran KPKNL
            // {
            //     path: 'KPKNL/:kode_wb/:thn',
            //     component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/index.vue'),
            //     name: 'KpknlDetailBPKH'
            // },
            {
                path: 'Pembayaran/SKKPKNL',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/TampilSK.vue'),
                name: 'SKKPKNLBPKH'
            },
            {
                path: 'Pembayaran/KPKNL/:kode_wb',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/index-kpknl.vue'),
                name: 'PembayaranKPKNLBPKH'
            },
            {
                path: 'Pembayaran/KPKNL/detail/:kode_wb/:thn',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/index.vue'),
                name: 'PembayaranKpknlDetailBPKH'
            },
            {
                path: 'Pembayaran/KPKNL/TambahDataPembayaran/:kode_wb/:tahun',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/TambahDataPembayaran.vue'),
                name: 'Tambah Data Pembayaran BPKH',
            },
            {
                path: 'Pembayaran/KPKNL/TambahSP3N/:kode_wb/:tahun',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/EditSP3N.vue'),
                name: 'EditDataSP3NBPKH',
            },
            {
                path: 'Pembayaran/KPKNL/CrashProgram/:kode_wb/:tahun',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/CrashProgram.vue'),
                name: 'CrashProgramBPKH',

            },
            {
                path: 'Pembayaran/KPKNL/Tambah_SPUPN/:kode_wb/:tahun',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/penyerahan.vue'),
                name: 'Tambah SPUPN BPKH',
            },
            {
                path: 'EditPembayaran/KPKNL/:idx',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranKPKNL/EditDataPembayaran.vue'),
                name: 'Edit Pembayaran BPKH',
            },

            //Pembayaran Angsur
            {
                path: 'Pembayaran/Angsur',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranAngsur/index-angsur.vue'),
                name: 'Pembayaran Angsur BPKH',
            },

            {
                path: 'Pembayaran/Pengangsuran/:kode_wb/:tahun/:idx',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranAngsur/index.vue'),
                name: 'Pengangsuran Detail BPKH',
            },

            {
                path: 'Pembayaran/Pengangsuran/Permohonan/:kode_wb/:tahun',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranAngsur/TambahPermohonan.vue'),
                name: 'Tambah Permohonan BPKH',
            },
            
            {
                path: 'Pembayaran/Pengangsuran/Tambah_Persetujuan/:kode_wb/:tahun',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranAngsur/TambahPersetujuan.vue'),
                name: 'Tambah Persetujuan BPKH',
            },

            {
                path: 'Pembayaran/Pengangsuran/Tambah_Data_Angsur/:kode_wb/:tahun/:idx',
                component: () => import('@/views/BPKHDashboard/pembayaran/PembayaranAngsur/TambahDataRencanaPengangsuran.vue'),
                name: 'Tambah Rencana Pengangsuran BPKH',
            },

            //Setup Hasil Verifikasi 
            {
                path: 'verifikasi/:kode',
                component: () => import('@/views/BPKHDashboard/VerifikasiPembayaran/list_verifikasi.vue'),
                name: 'VerifikasiKodeBPKH',
            },
            {
                path: 'Verifikasi_Pembayaran',
                component: () => import('@/views/BPKHDashboard/VerifikasiPembayaran/index.vue'),
                name: 'VerifikasiPembayaranBPKH',
            },
            {
                path: 'Verifikasi_Pembayaran/TambahVerifikasiBPKH',
                component: () => import('@/views/BPKHDashboard/VerifikasiPembayaran/tambah_verifikasi.vue'),
                name: 'TambahVerifikasiBPKH',
            },
            {
                path: 'DaftarRencana/:kode',
                component: () => import('@/views/BPKHDashboard/VerifikasiPembayaran/daftar_kegiatan.vue'),
                name: 'DaftarRencanaVerifikasiBPKH',
                props: true,
            },
            {
                path: 'HasilVerifikasi/:kode_verifikasi/:tahun/:kode_wb',
                component: () => import('@/views/BPKHDashboard/VerifikasiPembayaran/Hasil_verifikasi.vue'),
                name: 'HasilVerifikasiBPKH',
            },
            {
                path: 'Verifikasi_Pembayaran/Edit/:kode/:tahun',
                component: () => import('@/views/BPKHDashboard/VerifikasiPembayaran/EditDataVerifikasi.vue'),
                name: 'EditVerifikasiBPKH',
            },
            {
                path: 'HasilVerifikasiV1/:kode_wb',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/InputVerifikasiLegacy.vue'),
                name: 'HasilVerifikasiV1BPKH',
            },
            //Route manajemen user
            {
                path: 'DaftarUser',
                component: () => import('@/views/BPKHDashboard/User/DaftarUser.vue'),
                name: 'BpkhDaftarUser',
            },
            {
                path: 'DetailUser/:id',
                component: () => import('@/views/BPKHDashboard/User/DetailUser.vue'),
                name: 'BpkhDetailUser',
            },

            //Routing untuk Laporan Feature
            {
                path: 'Pelaporan',
                component: () => import('@/views/BPKHDashboard/Pelaporan/index.vue'),
                name: 'LaporanBPKH'
            },
            {
                path: 'Pelaporan/LaporanTarget',
                component: () => import('@/views/BPKHDashboard/Pelaporan/laporan_target.vue'),
                name: 'LaporanTargetBPKH',
            },
            {
                path: 'Pelaporan/LaporanRealisasi',
                component: () => import('@/views/BPKHDashboard/Pelaporan/laporan_realisasi.vue'),
                name: 'LaporanRealisasiBPKH',
            },
            {
                path: 'Pelaporan/LaporanPiutang',
                component: () => import('@/views/BPKHDashboard/Pelaporan/laporan_piutang.vue'),
                name: 'LaporanPiutangBPKH',
            },
            {
                path: 'Pelaporan/LaporanVerifikasi',
                component: () => import('@/views/BPKHDashboard/Pelaporan/laporan_verifikasi.vue'),
                name: 'LaporanVerifikasiBPKH',
            },

            //Manajemen PPKH
            {
                path: 'ManajemenPPKH/:kode_wb',
                component: () => import('@/views/BPKHDashboard/ManajemenPPKH/manajemenPPKH.vue'),
                name: 'ManajemenPPKHBPKH',
            },
        ]
    },
    {
        path: '/WajibBayar/',
        component: () => import('@/views/wajibbayardashboard/WajibBayarDashboard.vue'),
        name: 'WajibBayarDashboard1',
        children: [
            {
                path: '',
                // component: () => import ('@/views/dashboard/MenuUtama.vue'),
                component: () => import('@/views/wajibbayardashboard/Dashboard.vue'),
                // name: 'wb',
                name: 'WajibBayarDashboard',
            },
            //ini dipakai
            {
                path: 'FormulirSKPPKH/',
                component: () => import('@/views/wajibbayardashboard/WajibBayarSkppkh_dua.vue'),
                name: 'formulirskwb',
            },
            //ini dipakai
            {
                path: 'FormulirSKPPKH/detail/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/MenuUtamaPPKH.vue'),
                name: 'formuliwbskdetail',
            },
            //Pembayaran
            {
                path: 'pembayaran/',
                component: () => import('@/views/wajibbayardashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranKode.vue'),
                name: 'PembayaranWajibBayar'
            },
            {
                path: 'pembayaran/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranKode.vue'),
                name: 'PembayaranWajibBayarKode'
            },
            //Pembayaran Normal
            {
                //parameter tahun
                path: 'pembayaran_rinci/:kode_wb/:thn',
                component: () => import('@/views/wajibbayardashboard/pembayaran/MenuUtamaPembayaran/MenuUtamaPembayaranRinci.vue'),
                name: 'PembayaranWajibBayarRinci',
                props: true
            },

            {
                path: 'PembayaranLunas_WB/:kode_wb/:tahun',
                component: () => import('@/views/wajibbayardashboard/pembayaran/MenuUtamaPembayaran/telahDibayar.vue'),
                name: 'PembayaranLunaswb',
            },

            {
                path: 'invoice_billing',
                component: () => import('@/views/wajibbayardashboard/pembayaran/MenuUtamaPembayaran/Invoice_Pembayaran.vue'),
                name: 'InvoiceBillingWajibBayar',
            },

            {
                path: 'invoice_pembayaran/:idx',
                component: () => import('@/views/wajibbayardashboard/pembayaran/MenuUtamaPembayaran/Invoice_Pembayaran_dua.vue'),
                name: 'InvoiceBillingWajibBayarDetail',
            },

            //Pembayaran KPKNL
            {
                path: 'KPKNL/:kode_wb/:thn',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/index.vue'),
                name: 'KpknlDetailWB'
            },
            {
                path: 'Pembayaran/SKKPKNL',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/TampilSK.vue'),
                name: 'SKKPKNLWB'
            },
            {
                path: 'Pembayaran/KPKNL/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/index-kpknl.vue'),
                name: 'PembayaranKPKNLWB'
            },
            {
                path: 'Pembayaran/KPKNL/detail/:kode_wb/:thn',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/index.vue'),
                name: 'PembayaranKpknlDetailWB'
            },
            {
                path: 'Pembayaran/KPKNL/TambahDataPembayaran/:kode_wb/:tahun',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/TambahDataPembayaran.vue'),
                name: 'Tambah Data Pembayaran WB',
            },
            {
                path: 'Pembayaran/KPKNL/TambahSP3N/:kode_wb/:tahun',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/EditSP3N.vue'),
                name: 'EditDataSP3NWB',
            },
            {
                path: 'Pembayaran/KPKNL/CrashProgram/:kode_wb/:tahun',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/CrashProgram.vue'),
                name: 'CrashProgramWB',

            },
            {
                path: 'Pembayaran/KPKNL/Tambah_SPUPN/:kode_wb/:tahun',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/penyerahan.vue'),
                name: 'Tambah SPUPN WB',
            },
            {
                path: 'EditPembayaran/KPKNL/:idx',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranKPKNL/EditDataPembayaran.vue'),
                name: 'Edit Pembayaran WB',
            },

            //Pembayaran Angsur
            {
                path: 'Pembayaran/Angsur',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranAngsur/index-angsur.vue'),
                name: 'Pembayaran Angsur WB',
            },

            {
                path: 'Pembayaran/Pengangsuran/:kode_wb/:tahun/:idx',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranAngsur/index.vue'),
                name: 'Pengangsuran Detail WB',
            },

            {
                path: 'Pembayaran/Pengangsuran/Permohonan/:kode_wb/:tahun',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranAngsur/TambahPermohonan.vue'),
                name: 'Tambah Permohonan WB',
            },
            
            {
                path: 'Pembayaran/Pengangsuran/Tambah_Persetujuan/:kode_wb/:tahun',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranAngsur/TambahPersetujuan.vue'),
                name: 'Tambah Persetujuan WB',
            },

            {
                path: 'Pembayaran/Pengangsuran/Tambah_Data_Angsur/:kode_wb/:tahun/:idx',
                component: () => import('@/views/wajibbayardashboard/pembayaran/PembayaranAngsur/TambahDataRencanaPengangsuran.vue'),
                name: 'Tambah Rencana Pengangsuran WB',
            },

            //Baseline
            {
                path: 'Baseline/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/Baseline/DaftarBaseline.vue'),
                name: 'DaftarOprBaseline',
            },
            {
                path: 'BaselineNew/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/Baseline/Baseline.vue'),
                name: 'WbBaseline',
            },
            {
                path: 'Baseline/DetailBaseline/:kode_wb/:id_baseline',
                component: () => import('@/views/wajibbayardashboard/Baseline/DetailBaseline2.vue'),
                name: 'WbDetailBaseline',
            },
            {
                path: 'Baseline/DetailBaselineT0/:kode_wb/:id_baseline',
                component: () => import('@/views/wajibbayardashboard/Baseline/DetailBaselineT0.vue'),
                name: 'WbDetailBaselineT0',
            },
            {
                path: 'Baseline/DetailBaselinePertahun/:kode_wb/:id_baseline',
                component: () => import('@/views/wajibbayardashboard/Baseline/DetailBaselinePertahun.vue'),
                name: 'WbDetailBaselinePertahun',
            },

            {
                path: 'Persuratan/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/Persuratan/index.vue'),
                name: 'PersuratanPerWB',
            },

            //Piutang
            {
                path: 'PiutangWajibBayar/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/Piutang/DaftarPiutang.vue'),
                name: 'DaftarWBPiutang',
            },

            {
                path: 'PiutangWajibBayar/Detail/:kode_wb/:thn',
                component: () => import('@/views/wajibbayardashboard/Piutang/DetailPiutang.vue'),
                name: 'DetailWBPiutang',
            },

            // Harus dihapus Lagi 

            {
                path: 'persuratan',
                component: () => import('@/views/form_persuratan_online/DaftarSuratKeseluruhan.vue'),
                name: 'PersuratanWajibBayar'
            },
            {
                path: 'MenuUtama',
                component: () => import('@/views/dashboard/MenuUtama.vue'),
                name: 'MenuUtama'
            },

            //setup verifikasi 
            {
                path: 'DaftarRencanaWB/:kode',
                component: () => import('@/views/wajibbayardashboard/VerifikasiPembayaran/daftar_kegiatan.vue'),
                name: 'DaftarRencanaVerifikasiWajibBayar',
                props: true,
            },
            {
                path: 'HasilVerifikasi/:kode_verifikasi/:tahun/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/VerifikasiPembayaran/Hasil_verifikasi.vue'),
                name: 'HasilVerifikasiWB',
            },
            {
                path: 'HasilVerifikasiV1/:kode_wb',
                component: () => import('@/views/admindashboard/VerifikasiPembayaran/InputVerifikasiLegacy.vue'),
                name: 'HasilVerifikasiV1WB',
            },
            //Route manajemen user
            {
                path: 'DaftarUser',
                component: () => import('@/views/wajibbayardashboard/User/DaftarUser.vue'),
                name: 'WbDaftarUser',
            },
            {
                path: 'DetailUser/:id',
                component: () => import('@/views/wajibbayardashboard/User/DetailUser.vue'),
                name: 'WbDetailUser',
            },

            //PNBP Kompensasi
            {
                path: 'PNBPKompensasi/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/PNBPKompensasi/PNBPKompensasi.vue'),
                name: 'PNBPKompensasiWB',
            },

            //Manajemen PPKH
            {
                path: 'ManajemenPPKH/:kode_wb',
                component: () => import('@/views/wajibbayardashboard/ManajemenPPKH/manajemenPPKH.vue'),
                name: 'ManajemenPPKHWB',
            },
        ]
    },
    
    {
        path: '/DisplayDaftarSuratKeseluruhan',
        component: () => import('@/views/form_persuratan_online/DisplayDaftarSuratKeseluruhan/DisplayDaftarSuratKeseluruhan.vue'),
        name: 'DisplayDaftarSuratKeseluruhan'
    },
    {
        path: '/DisplayDaftarSuratBelumTerkirim',
        component: () => import('@/views/form_persuratan_online/DisplayDaftarSuratBelumTerkirim/DisplayDaftarSuratBelumTerkirim.vue'),
        name: 'DisplayDaftarSuratBelumTerkirim'
    },
    {
        path: '/FormulirTandaTanganPersuratanOnline',
        component: () => import('@/views/form_persuratan_online/FormulirTandaTanganPersuratanOnline/FormulirTandaTanganPersuratanOnline.vue'),
        name: 'FormulirTandaTanganPersuratanOnline'
    },
    {
        path: '/FormulirPengirimanPersuratanOnline',
        component: () => import('@/views/form_persuratan_online/FormulirPengirimanPersuratanOnline/FormulirPengirimanPersuratanOnline.vue'),
        name: 'FormulirPengirimanPersuratanOnline'
    },
    {
        path: '/DisplayDaftarSuratGagal',
        component: () => import('@/views/form_persuratan_online/DisplayDaftarSuratGagal/DisplayDaftarSuratGagal.vue'),
        name: 'DisplayDaftarSuratGagal'
    },
    {
        path: '/PemberitahuanJatuhTempo',
        component: () => import('@/views/form_persuratan_online/PemberitahuanJatuhTempo/PemberitahuanJatuhTempo.vue'),
        name: 'PemberitahuanJatuhTempo'
    },
    {
        path: '/MenuUtamaKonfigurasiSurat',
        component: () => import('@/views/form_persuratan_online/MenuUtamaKonfigurasiSurat/MenuUtamaKonfigurasiSurat.vue'),
        name: 'MenuUtamaKonfigurasiSurat'
    },
    {
        path: '/KonfigurasiJenisSurat',
        component: () => import('@/views/form_persuratan_online/KonfigurasiJenisSurat/KonfigurasiJenisSurat.vue'),
        name: 'KonfigurasiJenisSurat'
    },
]

//create router
const router = createRouter({
    history: createWebHashHistory(), //createWebHistory()
    routes  // config routes
})


router.beforeEach((to, from, next) => {
    
    const role = localStorage.getItem('roles');
    const isAuthenticated = localStorage.getItem("authenticated")
    const x = []
    /**  New */ 
    // x["AdminDashboard"] = "administrator"
    // x["DirekturDashboard"] = "direktur"
    // x["KasubditDashboard"] = "kasubdit"
    // x["KapokjaDashboard"] = "kapokja"
    // x["StaffOperator"] = "opr"
    // x["KPKNL"] = "kpknl"
    // x["WajibBayar"] = "wb"
    // x['BPKH'] = 'BPKH'
    /* Legacy */
    // x["AdminDashboard"] = "ADM"
    // x["DirekturDashboard"] = "ES2"
    // x["KasubditDashboard"] = "ES3"
    // x["KapokjaDashboard"] = "ES4"
    // x["StaffOperator"] = "OPR"
    // x["KPKNL"] = "KPKNL"
    // x["WajibBayar"] = "WB"
    // x['BPKH'] = 'BPKH'

    //handle user yang bel
    // um login balek ke login
    /**
    untuk handel ini mending diganti logika nya menjadi jika 
    tujuannya admin dashboard, KPKNL dashboard, Wajib Bayar Dashboard, 
    dan Operator Dashboard kembali ke login. menggunakna logika OR ||
    */

    // if ((to.name === "adminhome" || to.name === 'OperatorDashboard' || to.name === 'kpknldashboard' || to.name === 'WajibBayarDashboard' || to.name === 'KapokjaDashboard' || to.name === 'BPKHDashboard') && !isAuthenticated) {
    //     next({ name: 'LoginPage' })
    // }

    if (to.name == "adminhome" && isAuthenticated == false) {
        next({ name: 'LoginPage' })
        return
    }
    
    var date = new Date();
    
    const token = localStorage.getItem('token');
    axios.defaults.headers.common.Authorization = `Bearer ` + token
    // axios.defaults.withCredentials = true
    //
    if(token != null)
    {    
        axios.get( process.env.VUE_APP_BACKEND_URL + 'api/cek_token')
             .then(response => {
                
             }).catch(function (error){
                if(error.response.status == 401)
                {
                    localStorage.removeItem('token')
                    localStorage.setItem('authenticated',false)
                    localStorage.removeItem('id')
                    localStorage.removeItem('id_user')
                    localStorage.removeItem('roles')
                }
                next({ name: 'LoginPage' })
                return
             })
    }else{
        localStorage.removeItem('token')
        localStorage.setItem('authenticated',false)
        localStorage.removeItem('id')
        localStorage.removeItem('id_user')
        localStorage.removeItem('roles')
    }
    
    if(to.name == 'register')
    {
        next()
        return
    }
    
    if(to.name == 'Lupa Password')
    {
        next()
        return
    }

    if(to.name == 'verifikasiotp')
    {
        next()
        return
    }

    if(to.name == 'verifikasiUser')
    {
        next()
        return
    }

    if(to.name == 'InputOTP')
    {
        next()
        return
    }

    if(to.name == 'ResetPass')
    {
        next()
        return
    }

    if(to.name == 'GantiPassword')
    {
        next()
        return
    }

    if(to.name == 'ResetLupaPassword')
    {
        next()
        return
    }

    if(to.name == 'Konsultasi')
    {
        next()
        return
    }

    if(to.name == 'Statistik')
    {
        next()
        return
    }

    if (to.name == 'RegistrasiAkun')
    {
        next()
        return
    }

    if (isAuthenticated == false && to.name != 'LoginPage')
    {
        next({ name: 'LoginPage' })
        return
    }

    if(to.name == 'QrCode')
    {
        next()
        return
    }

    if(to.name == 'ObjekPnbp')
    {
        next()
        return
    }

    if(to.name == 'Panduan')
    {
        next()
        return
    }

    //handling user yang telah login gabisa balik login
    // if (to.name === "LoginPage" && isAuthenticated) {
    //     next({ name: role });
    //         return
    // }
    
    const parts = to.path.split('/')

    /*Legacy */
    // if ((isAuthenticated && x[parts[1]]) !== role) {
    //     if (role == 'ADM') {
    //         next({ name: 'adminhome' });
    //     }
    //     if (role == 'OPR') {
    //         next({ name: 'OperatorDashboard' });
    //     }
    //     if (role == 'KPKNL') {
    //         next({ name: 'kpknldashboard' });
    //     }
    //     if (role == 'WB') {
    //         next({ name: 'WajibBayarDashboard' });
    //     }
    //     if(role == 'ES4'){
    //         next({name: 'KapokjaDashboard'})
    //     }
    //      if(role == 'BPKH'){
    //         next({name: 'BPKHDashboard'})
    //     }
    // }

    // if (isAuthenticated) {
    //     if (role == 'ADM') {
    //         next({ name: 'adminhome' });
    //     }
    //     if (role == 'OPR') {
    //         next({ name: 'OperatorDashboard' });
    //     }
    //     if (role == 'KPKNL') {
    //         next({ name: 'kpknldashboard' });
    //     }
    //     if (role == 'WB') {
    //         next({ name: 'WajibBayarDashboard' });
    //     }
    //     if(role == 'ES4'){
    //         next({name: 'KapokjaDashboard'})
    //     }
    //      if(role == 'BPKH'){
    //         next({name: 'BPKHDashboard'})
    //     }
    // }

    /*New 8*/
    //handling user gabisa berubah prefix beda role
    if (isAuthenticated == false) {
        next({ name: 'LoginPage' });
            return
    }

    next();
})


export default router